import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.module.css";
import SignatureCanvas from "react-signature-canvas";
import { Row, Col, Container } from "react-bootstrap";
import $ from "jquery";
import {
  TextField,
  Checkbox,
  Radio,
  FormControlLabel,
  FormGroup,
  FormControl,
  Button,
  FormHelperText,
} from "@material-ui/core";
import { APP_LIVE_URL } from "../../config/config";
import {
  DateTimePicker,
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import axios from "axios";
import DateFnsUtils from "@date-io/date-fns";
import { CopyToClipboard } from "react-copy-to-clipboard";
import html2canvas from "html2canvas";
import { PhoneInput } from "react-international-phone";
import Select from "react-select";
import countryList from "react-select-country-list";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneNumberUtil } from "google-libphonenumber";
import NotificationToast from "../Notification/NotificationToast";

const loadFonts = () => {
  const link = document.createElement("link");
  link.href =
    "https://fonts.googleapis.com/css2?family=Amita&family=Bad+Script&family=Damion&family=Dancing+Script&family=Felipa&family=Julee&family=Kaushan+Script&family=Lugrasimo&family=Pacifico&family=Sofia&family=Yellowtail&display=swap";
  link.rel = "stylesheet";
  document.head.appendChild(link);
};

const cursiveFonts = [
  { name: "Your Signature", value: "'Amita', cursive" },
  { name: "Your Signature", value: "'Bad Script', cursive" },
  { name: "Your Signature", value: "'Damion', cursive" },
  { name: "Your Signature", value: "'Dancing Script', cursive" },
  { name: "Your Signature", value: "'Felipa', cursive" },
  { name: "Your Signature", value: "'Julee', cursive" },
  { name: "Your Signature", value: "'Kaushan Script', cursive" },
  { name: "Your Signature", value: "'Lugrasimo', cursive" },
  { name: "Your Signature", value: "'Pacifico', cursive" },
  { name: "Your Signature", value: "'Sofia', cursive" },
  { name: "Your Signature", value: "'Yellowtail', cursive" },
  // Add more cursive fonts here
];

const STATIC_TEXT_ANSWER_TYPES = [
  "text_only",
  "rich_text",
  "notice_text",
  "warning_text",
];

const isStaticTextAnswerType = (answerType) =>
  STATIC_TEXT_ANSWER_TYPES.includes(answerType);

const getQuestionColumnClass = (group, question) => {
  if (question.answerType === "label" || isStaticTextAnswerType(question.answerType)) {
    return "question-container col-sm-12";
  }

  if ((group?.column_layout || "single_column") === "double_column") {
    return "question-container col-sm-6";
  }

  return "question-container col-sm-12";
};

const renderStaticContent = (question) => {
  if (question.answerType === "text_only") {
    if (question.textType === "oli") {
      return (
        <ol style={{ paddingLeft: "20px", marginLeft: "20px" }}>
          {(question.textOnly || "")
            .split("\n")
            .filter((line) => line.trim() !== "")
            .map((line, index) => (
              <li
                key={index}
                style={{ listStyleType: "decimal", paddingLeft: "10px" }}
              >
                {line}
              </li>
            ))}
        </ol>
      );
    }

    if (question.textType === "sli") {
      return (
        <ul style={{ paddingLeft: "20px", marginLeft: "20px" }}>
          {(question.textOnly || "")
            .split("\n")
            .filter((line) => line.trim() !== "")
            .map((line, index) => (
              <li
                key={index}
                style={{ listStyleType: "disc", paddingLeft: "10px" }}
              >
                {line}
              </li>
            ))}
        </ul>
      );
    }

    return <p>{question.textOnly} </p>;
  }

  if (question.answerType === "notice_text") {
    return (
      <div className="alert alert-info">
        <div dangerouslySetInnerHTML={{ __html: question.textOnly || "" }} />
      </div>
    );
  }

  if (question.answerType === "warning_text") {
    return (
      <div className="alert alert-warning">
        <div dangerouslySetInnerHTML={{ __html: question.textOnly || "" }} />
      </div>
    );
  }

  return <div dangerouslySetInnerHTML={{ __html: question.textOnly || "" }} />;
};

const FormRenderer = ({
  formData,
  formTitle,
  formDescription,
  onSubmit,
  onToast,
  groups,
  allow_submit,
  responseMessage,
  draftData,
  saveDraft,
  progressStep,
}) => {
  const [formState, setFormState] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [validationSummary, setValidationSummary] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentStep, setCurrentStep] = useState(progressStep);
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [signatureType, setSignatureType] = useState("draw");
  const [signatureText, setSignatureText] = useState("");
  const [signatureClass, setSignatureClass] = useState("'Amita', cursive");
  const sigPadRefs = useRef([]);

  const [country, setCountry] = useState("");
  const [Address, setAddress] = useState("");
  const countryOptions = countryList().getData();
  const phoneInputRef = useRef(null);

  const [submission, setSubmission] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");
  const [toastTitle, setToastTitle] = useState("");

  // ── Single-page layout state/refs (ported from OBS_agent_FE) ──
  const [hoveredId, setHoveredId] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [showFloatingNav, setShowFloatingNav] = useState(false);
  const [mobileNavVisible, setMobileNavVisible] = useState(false);
  const sectionRefs = useRef([]);
  const heroRef = useRef(null);
  const tabsContainerRef = useRef(null);
  const isScrollingRef = useRef(false);
  const mobileNavTimerRef = useRef(null);

  const showToast = (message, type = "error", title) => {
    const cleanedMessage = String(message || "")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (typeof onToast === "function") {
      onToast(cleanedMessage, type, title || (type === "success" ? "Success" : "Error"));
      return;
    }

    setToastMessage("");
    setTimeout(() => {
      setToastMessage(cleanedMessage);
      setToastType(type);
      setToastTitle(title || (type === "success" ? "Success" : "Error"));
    }, 0);
  };

  // Build a "Please enter/select {Label} in {Step}" message for the first invalid field,
  // falling back to the format-specific error message (email/phone/etc.).
  const buildFieldWarning = (firstErrorFieldId, fieldErrors) => {
    const SELECT_TYPES_SP = ["dropdown", "select", "radio", "checkbox", "multiselect", "multi_select"];
    const firstQ = (formData || [])
      .flatMap((form) => form.questions || [])
      .find((x) => x.id === firstErrorFieldId);
    const firstGroup = (groups || []).find((g) => g.questions.includes(firstErrorFieldId));
    const firstMsg = fieldErrors[firstErrorFieldId];
    if (firstQ && (!firstMsg || firstMsg === "This field is required.")) {
      const verb = SELECT_TYPES_SP.includes(firstQ.answerType) ? "select" : "enter";
      const inStep = firstGroup?.group_title ? ` in ${firstGroup.group_title}` : "";
      return `Please ${verb} ${firstQ.questionText || "the highlighted field"}${inStep}`;
    }
    return firstGroup?.group_title
      ? `${firstMsg} (in ${firstGroup.group_title})`
      : firstMsg || "Please review the highlighted field.";
  };

  const hasUserEnteredData = (stateObj) => {
    if (!stateObj) return false;

    return Object.values(stateObj).some((value) => {
      if (value === undefined || value === null) return false;
      if (typeof value === "string") return value.trim() !== "";
      if (Array.isArray(value)) return value.length > 0;
      return true;
    });
  };

  useEffect(() => {
    loadFonts();
  }, []);

  useEffect(() => {
    if (draftData && draftData.length > 0) {
      const initialFormState = {};
      draftData[0].questions.forEach((question) => {
        initialFormState[question.id] = question.answer || "";
      });
      setFormState((prevState) => {
        if (!prevState || Object.keys(prevState).length === 0) {
          return initialFormState;
        }

        if (hasUserEnteredData(prevState)) {
          return {
            ...initialFormState,
            ...prevState,
          };
        }

        return initialFormState;
      });
    }
  }, [draftData]);

  // Track active section while scrolling (suppressed during programmatic scroll)
  useEffect(() => {
    const obs = [];
    sectionRefs.current.forEach((el, idx) => {
      if (!el) return;
      const o = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !isScrollingRef.current)
            setActiveTabIndex(idx);
        },
        { threshold: 0.3, rootMargin: "-60px 0px -40% 0px" },
      );
      o.observe(el);
      obs.push(o);
    });
    return () => obs.forEach((o) => o.disconnect());
  }, [groups]);

  // Show floating nav once the hero leaves the viewport
  useEffect(() => {
    if (!groups || groups.length <= 1) return;
    const el = heroRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => setShowFloatingNav(!entry.isIntersecting),
      { threshold: 0 },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [groups]);

  // Mobile: flash the floating nav on scroll activity, auto-hide after 2s
  useEffect(() => {
    const show = () => {
      if (!showFloatingNav) return;
      setMobileNavVisible(true);
      if (mobileNavTimerRef.current) clearTimeout(mobileNavTimerRef.current);
      mobileNavTimerRef.current = setTimeout(
        () => setMobileNavVisible(false),
        2000,
      );
    };
    window.addEventListener("scroll", show, { passive: true });
    window.addEventListener("touchmove", show, { passive: true });
    return () => {
      window.removeEventListener("scroll", show);
      window.removeEventListener("touchmove", show);
      if (mobileNavTimerRef.current) clearTimeout(mobileNavTimerRef.current);
    };
  }, [showFloatingNav]);

  const handleFocus = () => {
    const input = phoneInputRef.current?.input || phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  const phoneUtil = PhoneNumberUtil.getInstance();

  const isPhoneValid = (phone) => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };

  // A phone control seeded with only a dial code (e.g. "+1") has no national number;
  // treat that as empty so optional phones pass and required ones report "required".
  const isPhoneEmpty = (value) => {
    if (!value || !String(value).trim()) return true;
    try {
      const nsn = phoneUtil
        .parseAndKeepRawInput(String(value).trim())
        .getNationalNumber();
      return (
        nsn === undefined ||
        nsn === null ||
        String(nsn) === "" ||
        String(nsn) === "0"
      );
    } catch (error) {
      return true; // unparseable (e.g. just a dial code) → treat as empty
    }
  };

  const handleChangeCountry = (questionId, selectedOption) => {
    const selectedLabel = selectedOption ? selectedOption.label : "";

    setFormState((prevState) => ({
      ...prevState,
      [questionId]: selectedLabel,
    }));

    setFormErrors((prevState) => ({
      ...prevState,
      [questionId]: "",
    }));
    setValidationSummary(null);

    setCountry(selectedOption);

    //console.log("Selected Country Label:", selectedLabel);
  };

  const handleAddressSelect = async (questionId, place) => {
    //console.log("place", place);

    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const formattedAddress = data.results[0].formatted_address;

        const addressComponents = data.results[0].address_components;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        let zip = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        let full_address =
          streetAddress +
          address2 +
          ", " +
          city +
          ", " +
          state +
          ", " +
          zipCode +
          ", " +
          country;

        setFormState((prevState) => ({
          ...prevState,
          [questionId]: full_address || "",
        }));
        setFormErrors((prevState) => ({
          ...prevState,
          [questionId]: "",
        }));
        setValidationSummary(null);

        // Store the formatted address
        setAddress(full_address || "");
      } else {
        // console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      // console.error("Error fetching reverse geocoding data:", error);
    }
  };

  const handleChangePhone = (questionId, value) => {
    setFormState((prevState) => ({
      ...prevState,
      [questionId]: value,
    }));

    setFormErrors((prevState) => ({
      ...prevState,
      [questionId]: "",
    }));
    setValidationSummary(null);

    //console.log("Phone Number:", value);
  };

  const hasUngroupedQuestions = formData.some((form) =>
    form.questions.some((q) => !groups?.flat().includes(q.id)),
  );

  const ungroupedQuestions = formData
    .flatMap((form) => form.questions)
    .filter((question) => !groups.flat().includes(question.id));

  const handleChange = (questionId, value, inputFormat) => {
    if (inputFormat === "number_only") {
      value = value.replace(/[^0-9]/g, "");
    } else if (inputFormat === "alphabet_only") {
      value = value.replace(/[^a-zA-Z\s]/g, "");
    } else if (inputFormat === "alphanumeric") {
      value = value.replace(/[^a-zA-Z0-9\s]/g, "");
    }
    setFormState({
      ...formState,
      [questionId]: value,
    });
    setFormErrors({
      ...formErrors,
      [questionId]: "",
    });
    setValidationSummary(null);
  };

  const handleChangeSignature = (questionId, value) => {
    setSignatureText(value);
  };

  const handleChangeFixed = (questionId, value) => {
    setFormState({
      ...formState,
    });
  };

  // const handleCheckboxChange = (questionId, option, isChecked) => {
  //   const currentOptions = formState[questionId] || [];
  //   if (isChecked) {
  //     setFormState({
  //       ...formState,
  //       [questionId]: [...currentOptions, option],
  //     });
  //   } else {
  //     setFormState({
  //       ...formState,
  //       [questionId]: currentOptions.filter((opt) => opt !== option),
  //     });
  //   }
  //   setFormErrors({
  //     ...formErrors,
  //     [questionId]: "",
  //   });
  // };

  const handleCheckboxChange = (questionId, option, isChecked) => {
    setFormState((prevState) => {
      const currentOptions = prevState[questionId] || [];

      let updatedOptions;
      if (isChecked) {
        updatedOptions = [...currentOptions, option];
      } else {
        updatedOptions = currentOptions.filter((opt) => opt !== option);
      }
      // console.log("[updatedOptions] ", updatedOptions);
      return {
        ...prevState,
        [questionId]: updatedOptions,
      };
    });
    // console.log("[questionId] ", questionId);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [questionId]: "",
    }));
    setValidationSummary(null);
  };

  const handleFileChange = (questionId, event) => {
    if (event.target && event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("file", file);

        axios
          .post(
            `${process.env.REACT_APP_API_URL}forms/form_image_response`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          )
          .then((response) => {
            //console.log("handleFileChange: ", response);
            const imageUrl = response.data.default;
            setFormState((prevFormState) => ({
              ...prevFormState,
              [questionId]: imageUrl,
            }));
            setFormErrors((prevFormErrors) => ({
              ...prevFormErrors,
              [questionId]: "",
            }));
          })
          .catch((error) => {
            // console.error("There was an error uploading the image!", error);
          });
      }
    } else {
      // console.error("No file selected or event target is undefined.");
    }
  };

  const removeUploadedFile = (questionId) => {
    if (questionId && questionId !== "") {
      const formData = new FormData();
      setFormState((prevFormState) => ({
        ...prevFormState,
        [questionId]: "",
      }));
    }
  };

  const focusFirstErrorField = (firstErrorFieldId) => {
    if (!firstErrorFieldId) return;
    setTimeout(() => {
      const el = document.getElementById(`field-${firstErrorFieldId}`);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 50);
  };

  const validateCurrentStepFields = () => {
    const currentGroup = groups?.[currentStep];
    if (!currentGroup) {
      return {
        hasErrors: false,
        finalErrorMessage: "",
        fieldErrors: {},
        firstErrorFieldId: null,
        filerId: null,
        fullAddress: null,
      };
    }

    const fieldErrors = {};
    const requiredMessages = [];
    const validationMessages = [];
    let firstErrorFieldId = null;
    let filerId = null;
    let fullAddress = null;

    const groupedQuestions = currentGroup.questions
      .map((questionId) => formData?.[0]?.questions?.find((q) => q.id === questionId))
      .filter(Boolean);

    groupedQuestions.forEach((question) => {
      const value = formState[question.id];
      const isEmpty =
        question.validationValue === "validation_phone"
          ? isPhoneEmpty(value)
          : value === undefined ||
            value === null ||
            (typeof value === "string" && value.trim() === "") ||
            (Array.isArray(value) && value.length === 0);

      if (
        question.required &&
        !isStaticTextAnswerType(question.answerType) &&
        isEmpty
      ) {
        fieldErrors[question.id] = "This field is required.";
        requiredMessages.push(question.questionText || "Required field");
        if (!firstErrorFieldId) {
          firstErrorFieldId = question.id;
        }
      }
    });

    groupedQuestions
      .filter((question) => question.validationValue)
      .forEach((question) => {
        const rawValue = formState[question.id];
        const value = typeof rawValue === "string" ? rawValue.trim() : "";
        if (!value) return;

        const setValidationError = (message) => {
          validationMessages.push(message);
          if (!fieldErrors[question.id]) {
            fieldErrors[question.id] = message;
          }
          if (!firstErrorFieldId) {
            firstErrorFieldId = question.id;
          }
        };

        if (question.validationValue === "validation_email") {
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(value)) {
            setValidationError("Please enter a valid email address.");
          }
        }

        if (question.validationValue === "validation_phone") {
          if (!isPhoneEmpty(value) && !isPhoneValid(value)) {
            setValidationError("Please enter a valid phone number.");
          }
        }

        if (question.validationValue === "validation_zip") {
          const zipRegex = /^[A-Za-z0-9\s\-]{4,10}$/;
          if (!zipRegex.test(value)) {
            setValidationError("Please enter a valid postal code.");
          }
        }

        if (question.validationValue === "validation_address") {
          const addressRegex = /^[0-9a-zA-Z\s,.'\-#()]+$/;
          const wordCount = value.trim().split(/\s+/).length;

          if (!addressRegex.test(value) || wordCount < 5) {
            setValidationError(
              "Please enter a complete address containing at least 5 words.",
            );
          }
        }

        if (question.validationValue === "validation_city") {
          const cityRegex = /^[a-zA-Z\s.'\-áéíóúÁÉÍÓÚñÑüÜ]+$/;
          if (!cityRegex.test(value)) {
            setValidationError(
              "City must contain only letters, spaces, hyphens, or valid special characters.",
            );
          }
        }

        if (question.validationValue === "validation_state") {
          const stateRegex = /^[a-zA-Z\s]+$/;
          if (!stateRegex.test(value)) {
            setValidationError("State should contain only letters and spaces.");
          }
        }

        if (question.validationValue === "validation_ip") {
          const ipv4Regex =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          const ipv6Regex =
            /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|::(?:[a-fA-F0-9]{1,4}:){0,5}(?:[a-fA-F0-9]{1,4})$/;

          if (!ipv4Regex.test(value) && !ipv6Regex.test(value)) {
            setValidationError("Please enter a valid IP address (IPv4 or IPv6).");
          }
        }

        if (question.validationValue === "validation_filerId") {
          const filerIdRegex = /^[A-Z0-9]{0,10}$/;
          if (!filerIdRegex.test(value)) {
            setValidationError("Filer ID should be exactly 6 alphanumeric characters.");
          }
          filerId = value;
        }

        if (question.validationValue === "validation_fulladdress") {
          fullAddress = value;
        }
      });

    const requiredList = requiredMessages.length
      ? `Please fill out all required fields: ${requiredMessages.join(", ")}`
      : "";
    const uniqueValidationMessages = [...new Set(validationMessages)].join("<br />");
    const finalErrorMessage = [requiredList, uniqueValidationMessages]
      .filter(Boolean)
      .join("<br />");

    return {
      hasErrors: Object.keys(fieldErrors).length > 0,
      finalErrorMessage,
      fieldErrors,
      firstErrorFieldId,
      filerId,
      fullAddress,
    };
  };

  const handleSubmit = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const {
      hasErrors,
      finalErrorMessage,
      fieldErrors,
      firstErrorFieldId,
      filerId,
      fullAddress,
    } = validateCurrentStepFields();

    if (hasErrors) {
      const errorCount = Object.keys(fieldErrors).length;
      setFormErrors(fieldErrors);
      setValidationSummary({ count: errorCount, firstId: firstErrorFieldId });
      setErrorMessage("");
      showToast(buildFieldWarning(firstErrorFieldId, fieldErrors), "warning", "Missing Fields");
      focusFirstErrorField(firstErrorFieldId);
      return;
    }

    setFormErrors({});
    setValidationSummary(null);
    setErrorMessage("");

    setLoading(true);

    try {
      // Await the verification process before proceeding
      await verifyInfoSubmit(filerId, fullAddress);

      // Prepare form data to send
      const formDataToSend = formData.map((form) => ({
        title: form.title,
        id: form.id,
        questions: form.questions.map((question) => ({
          ...question,
          answer:
            question.answerType === "fixed"
              ? question.answer
              : formState[question.id],
        })),
        errorMessage: form.errorMessage,
      }));

      // Submit form data only after the verification is complete
      await onSubmit(formDataToSend);
      setTimeout(() => {
        setLoading(false);
      }, 4500);
    } catch (error) {
      // console.error("Error submitting the form:", error);
      setLoading(false);
    }
  };

  /*const handleSubmit = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const requiredQuestions = formData.flatMap((form) =>
      form.questions.filter((question) => question.required)
    );
    let hasErrors = false;

    requiredQuestions.forEach((question) => {
      if (!formState[question.id]) {
        hasErrors = true;
      }
    });

    if (hasErrors) {
      setErrorMessage("Please fill out all required fields.");
      setTimeout(() => {
        setErrorMessage("");
      }, 2500);
      return;
    }
    setLoading(true);
    //console.log("formData Before: ", formData);
    const formDataToSend = formData.map((form) => ({
      title: form.title,
      id: form.id,
      questions: form.questions.map((question) => ({
        ...question,
        //answer: formState[question.id],
        answer:
          question.answerType === "fixed"
            ? question.answer
            : formState[question.id],
      })),
      errorMessage: form.errorMessage,
    }));
    //console.log("formDataToSend: ", formDataToSend);
    onSubmit(formDataToSend);
    setTimeout(() => {
      setLoading(false);
    }, 4000);
  };*/

  /*const handleNextStep = () => {
    if (validateCurrentGroup()) {
      setCurrentStep(currentStep + 1);
    } else {
      setErrorMessage(
        "Please fill out all required fields in the current group."
      );
      setTimeout(() => {
        setErrorMessage("");
      }, 2500);
    }
  };

  const validateCurrentGroup = () => {
    const currentGroup = groups[currentStep];
    if (!currentGroup) return false;

    const hasEmptyRequiredFields = currentGroup.questions.some((questionId) => {
      const question = formData[0].questions.find((q) => q.id === questionId);
      if (question) {
        return question.required && !formState[question.id];
      }
    });

    return !hasEmptyRequiredFields;
  };

  const handleNextStep = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const { isValid, missingFields } = validateCurrentGroup();

    if (isValid) {
      setCurrentStep(currentStep + 1);
    } else {
      const fieldsList = missingFields.join(", ");
      setErrorMessage(`Please fill out all required fields: ${fieldsList}`);
      setTimeout(() => {
        setErrorMessage("");
      }, 4500);
    }
  };*/

  const handleNextStep = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const {
      hasErrors,
      finalErrorMessage,
      fieldErrors,
      firstErrorFieldId,
      filerId,
      fullAddress,
    } = validateCurrentStepFields();

    if (hasErrors) {
      const errorCount = Object.keys(fieldErrors).length;
      setFormErrors(fieldErrors);
      setValidationSummary({ count: errorCount, firstId: firstErrorFieldId });
      setErrorMessage("");
      showToast(buildFieldWarning(firstErrorFieldId, fieldErrors), "warning", "Missing Fields");
      focusFirstErrorField(firstErrorFieldId);
      return;
    }

    setFormErrors({});
    setValidationSummary(null);
    setErrorMessage("");

    if (filerId) {
      //console.log("Filer ID:", filerId);
    }

    if (fullAddress) {
      //console.log("Full Address:", fullAddress);
    }
    let isFilerVerified = true;
    setLoading(true);
    if (!filerId || !fullAddress) {
      isFilerVerified = await verifyInfo(filerId, fullAddress);
    }
    //console.log("isFilerVerified: ", isFilerVerified);
    if (isFilerVerified) {
      const formDataToSend = formData.map((form) => ({
        title: form.title,
        id: form.id,
        questions: form.questions.map((question) => ({
          ...question,
          answer:
            question.answerType === "fixed"
              ? question.answer
              : formState[question.id],
        })),
        errorMessage: form.errorMessage,
      }));

      await saveDraft(formDataToSend, currentStep + 1);
    }
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
  };

  // const validateCurrentGroup = () => {
  //   const currentGroup = groups[currentStep];
  //   if (!currentGroup) return { isValid: false, missingFields: [] };

  //   const missingFields = currentGroup.questions
  //     .map((questionId) => {
  //       const question = formData[0].questions.find((q) => q.id === questionId);

  //       if (question && question.required && !formState[question.id]) {
  //         return question.questionText; // Return the question text (field name) if it's required and empty
  //       }
  //       return null;
  //     })
  //     .filter(Boolean); // Filter out any null values

  //   return {
  //     isValid: missingFields.length === 0,
  //     missingFields: missingFields,
  //   };
  // };

  const validateCurrentGroup = () => {
    const currentGroup = groups[currentStep];
    if (!currentGroup) return { isValid: false, missingFields: [] };

    const missingFields = currentGroup.questions
      .map((questionId) => {
        const question = formData[0].questions.find((q) => q.id === questionId);
        const value = formState[question?.id];

        // Properly handle different value types
        const isEmpty =
          question?.validationValue === "validation_phone"
            ? isPhoneEmpty(value)
            : value === undefined ||
              value === null ||
              (typeof value === "string" && value.trim() === "") ||
              (Array.isArray(value) && value.length === 0);

        if (
          question &&
          question.required &&
          !isStaticTextAnswerType(question.answerType) &&
          isEmpty
        ) {
          return question.questionText; // Return field name if required and empty
        }
        return null;
      })
      .filter(Boolean); // remove nulls

    //console.log("[missingFields]", missingFields);

    return {
      isValid: missingFields.length === 0,
      missingFields,
    };
  };

  const verifyInfo = async (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    const TIMEOUT_MS = 6000; // 6 seconds timeout

    const verificationRequest = axios.post(
      `${process.env.REACT_APP_API_URL}forms/verify_info`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), TIMEOUT_MS),
    );

    try {
      const response = await Promise.race([verificationRequest, timeout]);
      //console.log("Verification response: ", response);
      setCurrentStep((prevStep) => prevStep + 1);

      // Return the response data for further use if needed
      return true;
    } catch (error) {
      let errorMessage = "";

      if (error.message === "Request timed out") {
        errorMessage =
          "Your FCC Filer verification or Address validation request is taking longer than expected. Please try again.";
      } else if (error.response) {
        const { status, data } = error.response;
        const formattedErrorMessage = data.errors
          ? String(data.errors).replace(/,/g, "<br />")
          : null;

        switch (status) {
          case 411:
            errorMessage = `Invalid Filer ID<br />${
              formattedErrorMessage ||
              "Both Filer ID and address validation failed."
            }`;
            break;
          case 410:
            errorMessage = "Invalid FCC Filer ID.";
            break;
          case 409:
            errorMessage = formattedErrorMessage || "Address validation failed";
            break;
          default:
            errorMessage = "An unexpected error occurred.";
        }
      } else {
        errorMessage = "There was an error verifying the information!";
      }

      setErrorMessage(errorMessage);
      setTimeout(() => {
        setErrorMessage("");
      }, 10000);
      return false;
    } finally {
      // Reset the loading state after the request completes
      setLoading(false);
    }
  };

  const verifyInfoSubmit = async (filerId, fullAddress) => {
    const payload = {
      filer_id: filerId,
      full_address: fullAddress,
    };

    const TIMEOUT_MS = 6000; // 6 seconds timeout

    // Create a timeout promise
    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), TIMEOUT_MS),
    );

    try {
      // Use Promise.race to handle both the request and the timeout
      const response = await Promise.race([
        axios.post(
          `${process.env.REACT_APP_API_URL}forms/verify_info`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        ),
        timeout,
      ]);

      //console.log("Verification response: ", response);
      setSubmission(true);
      return response;
    } catch (error) {
      setSubmission(false);

      let errorMessage = "";

      if (error.message === "Request timed out") {
        errorMessage =
          "Your FCC Filer verification or Address validation request is taking longer than expected. Please try again.";
      } else if (error.response) {
        const { status, data } = error.response;

        window.scrollTo({ top: 0, behavior: "smooth" });

        const formattedErrorMessage = data.errors
          ? String(data.errors).replace(/,/g, "<br />")
          : null;

        switch (status) {
          case 411:
            errorMessage = `Invalid Filer ID<br />${
              formattedErrorMessage ||
              "Both Filer ID and address validation failed."
            }`;
            break;
          case 410:
            errorMessage = "Invalid FCC Filer ID.";
            break;
          case 409:
            errorMessage = formattedErrorMessage || "Address validation failed";
            break;
          default:
            errorMessage = "An unexpected error occurred.";
        }
      } else {
        errorMessage = "There was an error verifying the information!";
      }

      showToast(errorMessage, "error");
      setErrorMessage("");

      throw error;
    }
  };

  const clearSignature = (index) => {
    if (sigPadRefs.current[index]) {
      sigPadRefs.current[index].clear();
      $("#divSig" + index).hide();
      $(".clsimgSig").attr("src", "");
      $(".clsimgSig").hide();
    }
  };

  const previewSignature = (index) => {
    if (sigPadRefs.current[index]) {
      const dataUrl = sigPadRefs.current[index].toDataURL();
      var data = sigPadRefs.current[index]
        .getTrimmedCanvas()
        .toDataURL("image/svg+xml");
      $("#divSig" + index).show();
      $(".clsimgSig").show();
      $(".clsimgSig").attr("src", data);
      //console.log("Signature Preview:", dataUrl);
      // You can do something with the dataUrl, like displaying it or saving it
    }
  };

  const saveSignature = async (index) => {
    const signaturePad = sigPadRefs.current[index];

    if (signaturePad && !signaturePad.isEmpty()) {
      try {
        // Generate the trimmed signature as a base64 string
        const trimmedDataUrl = signaturePad
          .getTrimmedCanvas()
          .toDataURL("image/svg+xml");

        // Prepare the JSON payload
        const payload = {
          signature: trimmedDataUrl,
        };

        // Send the signature data as JSON to the server
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}forms/form_signature_response`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        // Check if response status is 200 and contains the expected data
        if (response.status === 200 && response.data.default) {
          // Extract the image URL from the response
          const imageUrl = response.data.default;

          // Update the form state with the new image URL
          setFormState((prevFormState) => ({
            ...prevFormState,
            [index]: imageUrl,
          }));

          // Clear any previous errors related to this signature
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            [index]: "",
          }));

          showToast("Signature saved successfully.", "success", "Saved");
          setErrorMessage("");

          //console.log(`Signature ${index + 1} saved successfully:`, imageUrl);
        } else {
          throw new Error(
            `Unexpected response format or status: ${response.status}`,
          );
        }
      } catch (error) {
        // Handle errors and update state
        // console.error(
        //   `Error uploading the signature for index ${index + 1}:`,
        //   error.message,
        // );

        // Optionally, update form errors state to show the error message
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [index]: error.message || "Failed to save signature",
        }));
        showToast("Failed to save signature. Please try again.", "error");
        setErrorMessage("");
      }
    } else {
      showToast("Signature is empty.", "error");
      setErrorMessage("");
      //console.log(`Signature ${index + 1} is empty or does not exist.`);
    }
  };

  const saveChooseImage = async (index) => {
    const element = document.getElementById("styled-text-container" + index);
    if (element) {
      try {
        const canvas = await html2canvas(element, {
          scale: 2,
          backgroundColor: null,
        });
        const imgData = canvas.toDataURL("image/png");
        const payload = {
          signature: imgData,
        };

        // Send the signature data as JSON to the server
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}forms/form_signature_choose_response`,
          JSON.stringify(payload),
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        if (response.status === 200 && response.data.default) {
          // Extract the image URL from the response
          const imageUrl = response.data.default;

          // Update the form state with the new image URL
          setFormState((prevFormState) => ({
            ...prevFormState,
            [index]: imageUrl,
          }));

          // Clear any previous errors related to this signature
          setFormErrors((prevFormErrors) => ({
            ...prevFormErrors,
            [index]: "",
          }));

          showToast("Signature saved successfully.", "success", "Saved");
          setErrorMessage("");
          //console.log(`Signature ${index + 1} saved successfully:`, imageUrl);
        } else {
          throw new Error(
            `Unexpected response format or status: ${response.status}`,
          );
        }
      } catch (error) {
        setFormErrors((prevFormErrors) => ({
          ...prevFormErrors,
          [index]: error.message || "Failed to save signature",
        }));
        showToast("Failed to save signature. Please try again.", "error");
        setErrorMessage("");
      }
    } else {
      showToast("Signature is empty.", "error");
      setErrorMessage("");
      //console.log(`Signature ${index + 1} is empty or does not exist.`);
    }
  };

  const downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url = APP_LIVE_URL + "files_data/form_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          // console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "File not found.",
      });
      /*setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);*/
    }
  };

  //Show Groups by sequence Number
  if (groups) {
    groups = groups.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
  }

  const currentGroup = groups && groups.length > 0 ? groups[currentStep] : null;

  // ── Single-page layout helpers (ported from OBS_agent_FE) ──
  const getQuestionColClassSP = (question, group) => {
    if (!question) return "col-sm-12";
    if (
      question.answerType === "label" ||
      isStaticTextAnswerType(question.answerType)
    )
      return "col-sm-12";
    if (group && group.column_layout === "double_column") return "col-sm-6";
    return "col-sm-12";
  };

  const smoothScrollTo = (targetY, duration = 650) => {
    const startY = window.scrollY;
    const diff = targetY - startY;
    if (Math.abs(diff) < 2) return;
    const ease = (t) =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    let startTime = null;
    const tick = (now) => {
      if (!startTime) startTime = now;
      const progress = Math.min((now - startTime) / duration, 1);
      window.scrollTo(0, startY + diff * ease(progress));
      if (progress < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  const scrollToSection = (index) => {
    setActiveTabIndex(index);
    const el = sectionRefs.current[index];
    if (!el) return;
    isScrollingRef.current = true;
    setTimeout(() => {
      isScrollingRef.current = false;
    }, 750);
    const rect = el.getBoundingClientRect();
    smoothScrollTo(window.scrollY + rect.top - 80, 650);
  };

  const validateAllGroupsSP = () => {
    if (!groups || !groups.length)
      return {
        isValid: true,
        missingFields: [],
        missingFieldIds: [],
        firstInvalidId: null,
      };
    const missingFields = [];
    const missingFieldIds = [];
    let firstInvalidId = null;
    groups.forEach((group) => {
      group.questions.forEach((questionId) => {
        const q = formData?.[0]?.questions.find((x) => x.id === questionId);
        if (!q || !q.required || isStaticTextAnswerType(q.answerType)) return;
        const val = formState[q.id];
        const empty =
          q.validationValue === "validation_phone"
            ? isPhoneEmpty(val)
            : val === undefined ||
              val === null ||
              (typeof val === "string" && val.trim() === "") ||
              (Array.isArray(val) && val.length === 0);
        if (empty) {
          missingFields.push(q.questionText);
          missingFieldIds.push(q.id);
          if (!firstInvalidId) firstInvalidId = q.id;
        }
      });
    });
    return {
      isValid: missingFields.length === 0,
      missingFields,
      missingFieldIds,
      firstInvalidId,
    };
  };

  const handleSubmitSinglePage = async () => {
    const { isValid, missingFieldIds, firstInvalidId } = validateAllGroupsSP();
    let hasErrors = !isValid;
    const fieldErrors = {};
    let firstErrorFieldId = firstInvalidId;
    let filerId = null;
    let fullAddress = null;

    if (!isValid) {
      missingFieldIds.forEach((id) => {
        fieldErrors[id] = "This field is required.";
      });
    }

    const allValQs = formData.flatMap((form) =>
      form.questions.filter((q) => q.validationValue),
    );
    allValQs.forEach((q) => {
      const raw = formState[q.id];
      const value = typeof raw === "string" ? raw.trim() : "";
      if (!value) return;
      const setErr = (msg) => {
        hasErrors = true;
        if (!fieldErrors[q.id]) fieldErrors[q.id] = msg;
        if (!firstErrorFieldId) firstErrorFieldId = q.id;
      };
      if (q.validationValue === "validation_email") {
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value))
          setErr("Please enter a valid email address.");
      }
      if (q.validationValue === "validation_phone") {
        if (!isPhoneEmpty(value) && !isPhoneValid(value))
          setErr("Please enter a valid phone number.");
      }
      if (q.validationValue === "validation_zip") {
        if (!/^[A-Za-z0-9\s\-]{4,10}$/.test(value))
          setErr("Please enter a valid postal code.");
      }
      if (q.validationValue === "validation_address") {
        if (
          !/^[0-9a-zA-Z\s,.'\-#()]+$/.test(value) ||
          value.trim().split(/\s+/).length < 5
        )
          setErr(
            "Please enter a complete address containing at least 5 words.",
          );
      }
      if (q.validationValue === "validation_city") {
        if (!/^[a-zA-Z\s.'\-áéíóúÁÉÍÓÚñÑüÜ]+$/.test(value))
          setErr(
            "City must contain only letters, spaces, hyphens, or valid special characters.",
          );
      }
      if (q.validationValue === "validation_state") {
        if (!/^[a-zA-Z\s]+$/.test(value))
          setErr("State should contain only letters and spaces.");
      }
      if (q.validationValue === "validation_ip") {
        const ipv4Regex =
          /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        const ipv6Regex =
          /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|::(?:[a-fA-F0-9]{1,4}:){0,5}(?:[a-fA-F0-9]{1,4})$/;
        if (!ipv4Regex.test(value) && !ipv6Regex.test(value))
          setErr("Please enter a valid IP address (IPv4 or IPv6).");
      }
      if (q.validationValue === "validation_filerId") {
        if (!/^[A-Z0-9]{0,10}$/.test(value))
          setErr("Filer ID should be exactly 6 alphanumeric characters.");
        if (value) filerId = value;
      }
      if (q.validationValue === "validation_fulladdress" && value)
        fullAddress = value;
    });

    if (hasErrors) {
      const errorCount = Object.keys(fieldErrors).length;
      setFormErrors(fieldErrors);
      setValidationSummary({ count: errorCount, firstId: firstErrorFieldId });
      showToast(buildFieldWarning(firstErrorFieldId, fieldErrors), "warning", "Missing Fields");
      setErrorMessage("");
      if (firstErrorFieldId) {
        setTimeout(() => {
          const el = document.getElementById(`sp-field-${firstErrorFieldId}`);
          if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 50);
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    }

    setFormErrors({});
    setValidationSummary(null);
    setErrorMessage("");
    setLoading(true);
    try {
      await verifyInfoSubmit(filerId, fullAddress);
      const formDataToSend = formData.map((form) => ({
        title: form.title,
        id: form.id,
        questions: form.questions.map((q) => ({
          ...q,
          answer: q.answerType === "fixed" ? q.answer : formState[q.id],
        })),
        errorMessage: form.errorMessage,
      }));
      await onSubmit(formDataToSend);
      setTimeout(() => {
        setLoading(false);
      }, 4500);
    } catch (err) {
      setLoading(false);
    }
  };
  // ── End single-page helpers ──

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <NotificationToast
        message={toastMessage}
        type={toastType}
        title={toastTitle}
        onDismiss={() => setToastMessage("")}
      />
      <div className="form-renderer-container">
        {currentGroup ? (
          <>
            {/* ── Single-page layout (ported from OBS_agent_FE) ── */}
            <div
              ref={heroRef}
              style={{
                background: "#F5F6FA",
                borderRadius: "16px",
                marginBottom: "1.5rem",
                overflow: "hidden",
                border: "1px solid #dce2ec",
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              }}
            >
              <div style={{ padding: "36px 48px 28px", textAlign: "center" }}>
                <h2
                  style={{
                    margin: "0 0 10px",
                    fontSize: "1.85rem",
                    fontWeight: 700,
                    color: "#1c2b46",
                    lineHeight: 1.25,
                    letterSpacing: "-0.02em",
                  }}
                >
                  {formTitle || "Untitled Form"}
                </h2>
                {formDescription && (
                  <p
                    style={{
                      margin: "0 auto",
                      fontSize: "15px",
                      color: "#526484",
                      lineHeight: 1.7,
                      maxWidth: "600px",
                    }}
                  >
                    <span
                      dangerouslySetInnerHTML={{ __html: formDescription }}
                    />
                  </p>
                )}
              </div>
              {groups && groups.length > 1 && (
                <div
                  ref={tabsContainerRef}
                  className="obs-hero-tabs"
                  style={{ borderTop: "1px solid #dce2ec" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      overflowX: "auto",
                      padding: "0 24px",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {groups.map((group, index) => {
                      const isActive = activeTabIndex === index;
                      return (
                        <button
                          key={group.id}
                          onClick={() => scrollToSection(index)}
                          type="button"
                          className="obs-tab-btn"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "9px",
                            padding: "14px 16px",
                            border: "none",
                            borderBottom: isActive
                              ? "3px solid #1ee0ac"
                              : "3px solid transparent",
                            background: "transparent",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                            transition: "border-color 0.2s ease",
                            outline: "none",
                            flexShrink: 0,
                          }}
                        >
                          <span
                            className="obs-tab-circle"
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "24px",
                              height: "24px",
                              minWidth: "24px",
                              borderRadius: "50%",
                              background: isActive ? "#1ee0ac" : "#e4e9f2",
                              color: isActive ? "#0d1b38" : "#6b7c95",
                              fontSize: "11px",
                              fontWeight: 700,
                            }}
                          >
                            {index + 1}
                          </span>
                          <span
                            className="obs-tab-label"
                            style={{
                              fontSize: "12px",
                              fontWeight: 600,
                              letterSpacing: "0.01em",
                              color: isActive ? "#0d1b38" : "#6b7c95",
                            }}
                          >
                            {group.group_title}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <style>{`
              .obs-hero-tabs > div::-webkit-scrollbar { display: none; }
              .obs-rich-text-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
              .obs-rich-text-scroll table { min-width: max-content; border-collapse: collapse; }
              .obs-rich-text-scroll::-webkit-scrollbar { height: 4px; }
              .obs-rich-text-scroll::-webkit-scrollbar-thumb { background: #c8d3df; border-radius: 4px; }
              .custom-tooltip-wrapper { position: relative; display: inline-block; }
              .custom-tooltip-box {
                visibility: hidden;
                opacity: 0;
                position: absolute;
                top: 50%;
                left: 120%;
                transform: translateY(-50%);
                background-color: #000;
                color: #fff !important;
                border-radius: 6px;
                padding: 10px 14px;
                font-size: 11px;
                line-height: 1.5;
                font-weight: 500;
                z-index: 999;
                min-width: 380px;
                max-width: 580px !important;
                transition: opacity 0.3s ease;
                text-align: left;
                max-height: 250px;
                overflow-y: auto;
                padding-right: 8px;
                scrollbar-width: thin;
                scrollbar-color: #f1f1f1 rgba(0, 0, 0, 0.75);
              }
              .custom-tooltip-box, .custom-tooltip-box * { color: #fff !important; }
              .custom-tooltip-box::after {
                content: "";
                position: absolute;
                top: 50%;
                left: -6px;
                margin-top: -6px;
                border-width: 6px;
                border-style: solid;
                border-color: transparent rgba(0, 0, 0, 0.75) transparent transparent;
              }
              .custom-tooltip-wrapper:hover .custom-tooltip-box { visibility: visible; opacity: 1; }
              .custom-tooltip-box ul li { list-style-type: disc; margin-left: 20px; }
              .custom-tooltip-box ol li { list-style-type: decimal; margin-left: 20px; }
              @media (max-width: 768px) {
                .custom-tooltip-box {
                  left: 50%;
                  top: 110%;
                  transform: translateX(-50%);
                  min-width: 280px;
                  max-width: 90vw;
                  padding: 12px 16px;
                  font-size: 12px;
                  text-align: left;
                }
                .custom-tooltip-box::after {
                  top: -6px;
                  left: 50%;
                  transform: translateX(-50%);
                  border-color: transparent transparent rgba(0, 0, 0, 0.85) transparent;
                }
              }
              .form-renderer-container .form-label {
                font-size: 12.5px !important;
                font-weight: 600 !important;
                color: #526484 !important;
                margin-bottom: 5px !important;
                letter-spacing: 0.01em;
              }
              .form-renderer-container .form-label.obs-section-label {
                font-size: 13.5px !important;
                font-weight: 700 !important;
                color: #344357 !important;
                margin-bottom: 4px !important;
              }
              @media (max-width: 768px) {
                .obs-hero-tabs { display: none !important; }
                .obs-floating-nav {
                  opacity: 0;
                  pointer-events: none;
                  transition: opacity 0.35s ease !important;
                  right: 8px !important;
                  padding: 5px 4px !important;
                  gap: 3px !important;
                  border-radius: 20px !important;
                }
                .obs-floating-nav.obs-mobile-visible {
                  opacity: 1;
                  pointer-events: auto;
                }
                .obs-pill-btn {
                  width: 18px !important;
                  height: 18px !important;
                  font-size: 8px !important;
                }
              }
              @media (min-width: 769px) and (max-width: 1024px) {
                .obs-hero-tabs .obs-tab-btn { padding: 12px 10px !important; }
                .obs-hero-tabs .obs-tab-label { font-size: 11px !important; }
                .obs-hero-tabs .obs-tab-circle {
                  width: 22px !important;
                  height: 22px !important;
                  min-width: 22px !important;
                  font-size: 10px !important;
                }
                .obs-hero-tabs > div { padding: 0 12px !important; }
              }
            `}</style>

            {groups && groups.length > 1 && (
              <div
                className={`obs-floating-nav${mobileNavVisible ? " obs-mobile-visible" : ""}`}
                style={{
                  display: showFloatingNav ? "flex" : "none",
                  position: "fixed",
                  right: "14px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 1000,
                  background: "#fff",
                  borderRadius: "30px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
                  padding: "7px 5px",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "4px",
                  transition: "opacity 0.35s ease",
                }}
              >
                {groups.map((group, index) => {
                  const isActive = activeTabIndex === index;
                  return (
                    <button
                      key={group.id}
                      onClick={() => scrollToSection(index)}
                      title={group.group_title}
                      className="obs-pill-btn"
                      style={{
                        width: "22px",
                        height: "22px",
                        borderRadius: "50%",
                        background: isActive ? "#0d1b38" : "#e4e9f2",
                        border: isActive ? "none" : "1px solid #c8d3df",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: isActive ? "#fff" : "#6b7c95",
                        fontSize: "9px",
                        fontWeight: 700,
                        transition: "all 0.25s ease",
                        padding: 0,
                        flexShrink: 0,
                      }}
                    >
                      {index + 1}
                    </button>
                  );
                })}
              </div>
            )}

            <div>
              <div>
                {groups.map((group, groupIndex) => (
                  <div
                    key={group.id}
                    id={`sp-group-${group.id}`}
                    ref={(el) => (sectionRefs.current[groupIndex] = el)}
                    className="mb-4"
                    style={{
                      scrollMarginTop: "80px",
                      background: "#fff",
                      borderRadius: "14px",
                      boxShadow: "0 1px 12px rgba(0,0,0,0.08)",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "1px solid #e5e9f2",
                        padding: "20px 24px 18px",
                        background: "#fff",
                      }}
                    >
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <h6
                          style={{
                            margin: "0 0 3px",
                            fontWeight: 700,
                            fontSize: "15px",
                            color: "#1c2b46",
                            letterSpacing: "0",
                          }}
                        >
                          Step {groupIndex + 1} — {group.group_title}
                        </h6>
                        {group.group_desc && (
                          <p
                            style={{
                              margin: 0,
                              fontSize: "13px",
                              color: "#8094ae",
                              lineHeight: 1.55,
                            }}
                            dangerouslySetInnerHTML={{
                              __html: group.group_desc.replace(/\n/g, "<br />"),
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="card-inner">
                      <div className="row g-gs">
                        {group.questions
                          .map((qid) =>
                            formData[0]?.questions.find((q) => q.id === qid),
                          )
                          .filter(Boolean)
                          .sort((a, b) => a.sequenceNumber - b.sequenceNumber)
                          .map((question) => {
                            const value =
                              formState[question.id] ||
                              question.defaultValue ||
                              "";
                            const colClass = getQuestionColClassSP(
                              question,
                              group,
                            );
                            const hasFieldError = Boolean(
                              formErrors[question.id],
                            );
                            const errorBorderStyle = hasFieldError
                              ? {
                                  borderColor: "#e85347",
                                  boxShadow: "0 0 0 1px #e85347",
                                }
                              : {};
                            return (
                              <div
                                key={question.id}
                                id={`sp-field-${question.id}`}
                                className={`question-container ${colClass}`}
                              >
                                <div className="form-group question-text mb-0">
                                  {question.answerType === "label" ? (
                                    <label className="form-label obs-section-label">
                                      {question.questionText}{" "}
                                      {question.required && (
                                        <sup className="text-danger">*</sup>
                                      )}
                                      {question.tooltip &&
                                        question.tooltip.trim() !== "" && (
                                          <div className="custom-tooltip-wrapper">
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                              }}
                                            ></em>
                                            <div className="custom-tooltip-box">
                                              <p>{question.tooltip}</p>
                                            </div>
                                          </div>
                                        )}
                                    </label>
                                  ) : !isStaticTextAnswerType(
                                      question.answerType,
                                    ) ? (
                                    <label className="form-label">
                                      {question.questionText}{" "}
                                      {question.required && (
                                        <sup className="text-danger">*</sup>
                                      )}
                                      {question.tooltip &&
                                        question.tooltip.trim() !== "" && (
                                          <div className="custom-tooltip-wrapper">
                                            <em
                                              className="icon ni ni-info"
                                              style={{
                                                color: "#6576ff",
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                                fontSize: "16px",
                                              }}
                                            ></em>
                                            <div className="custom-tooltip-box">
                                              <p>{question.tooltip}</p>
                                            </div>
                                          </div>
                                        )}
                                    </label>
                                  ) : null}
                                  {question.answerType === "text_only" &&
                                    (question.textType === "oli" ? (
                                      <ol
                                        style={{
                                          paddingLeft: "20px",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        {(question.textOnly || "")
                                          .split("\n")
                                          .filter((l) => l.trim() !== "")
                                          .map((line, li) => (
                                            <li
                                              key={li}
                                              style={{
                                                listStyleType: "decimal",
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              {line}
                                            </li>
                                          ))}
                                      </ol>
                                    ) : question.textType === "sli" ? (
                                      <ul
                                        style={{
                                          paddingLeft: "20px",
                                          marginLeft: "20px",
                                        }}
                                      >
                                        {(question.textOnly || "")
                                          .split("\n")
                                          .filter((l) => l.trim() !== "")
                                          .map((line, li) => (
                                            <li
                                              key={li}
                                              style={{
                                                listStyleType: "disc",
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              {line}
                                            </li>
                                          ))}
                                      </ul>
                                    ) : (
                                      <p>{question.textOnly}</p>
                                    ))}
                                  {question.answerType === "rich_text" && (
                                    <div className="obs-rich-text-scroll">
                                      <div
                                        style={{
                                          fontSize: "14px",
                                          lineHeight: 1.65,
                                          color: "#526484",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: question.textOnly || "",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {question.answerType === "notice_text" && (
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "12px",
                                        alignItems: "flex-start",
                                        background: "#eef3ff",
                                        border: "1px solid #c4d0ff",
                                        borderLeft: "4px solid #6576ff",
                                        borderRadius: "6px",
                                        padding: "14px 16px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <em
                                        className="icon ni ni-info-fill"
                                        style={{
                                          color: "#6576ff",
                                          fontSize: "18px",
                                          marginTop: "1px",
                                          flexShrink: 0,
                                        }}
                                      ></em>
                                      <div
                                        style={{
                                          fontSize: "13.5px",
                                          color: "#364a63",
                                          lineHeight: 1.6,
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: question.textOnly || "",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {question.answerType === "warning_text" && (
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "12px",
                                        alignItems: "flex-start",
                                        background: "#fff8ea",
                                        border: "1px solid #ffd591",
                                        borderLeft: "4px solid #f4a600",
                                        borderRadius: "6px",
                                        padding: "14px 16px",
                                        marginBottom: "4px",
                                      }}
                                    >
                                      <em
                                        className="icon ni ni-alert-fill"
                                        style={{
                                          color: "#f4a600",
                                          fontSize: "18px",
                                          marginTop: "1px",
                                          flexShrink: 0,
                                        }}
                                      ></em>
                                      <div
                                        style={{
                                          fontSize: "13.5px",
                                          color: "#364a63",
                                          lineHeight: 1.6,
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: question.textOnly || "",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {question.imageUrl &&
                                    !isStaticTextAnswerType(
                                      question.answerType,
                                    ) && (
                                      <a
                                        onClick={() =>
                                          downloadPdf(question.imageUrl)
                                        }
                                        style={{
                                          float: "right",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <span className="badge badge-outline-primary">
                                          <em className="icon ni ni-download"></em>{" "}
                                          Download File
                                        </span>
                                      </a>
                                    )}
                                </div>

                                {question.answerType === "input" && (
                                  <div className="form-group mb-0">
                                    <div className="form-control-wrap address_cont">
                                      {question.validationValue ===
                                      "validation_phone" ? (
                                        <PhoneInput
                                          className="customStyle-phone_input-add_sharelink_lead"
                                          required
                                          defaultCountry={"us"}
                                          value={formState[question.id] || ""}
                                          onChange={(v) =>
                                            handleChangePhone(question.id, v)
                                          }
                                          ref={phoneInputRef}
                                          onFocus={handleFocus}
                                          inputStyle={
                                            formErrors[question.id]
                                              ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" }
                                              : undefined
                                          }
                                          countrySelectorStyleProps={{
                                            buttonStyle: formErrors[question.id]
                                              ? { borderColor: "#e85347" }
                                              : undefined,
                                          }}
                                        />
                                      ) : question.validationValue ===
                                        "validation_fulladdress" ? (
                                        <GooglePlacesAutocomplete
                                          apiKey={
                                            process.env
                                              .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                          }
                                          apiOptions={{ loading: "async" }}
                                          selectProps={{
                                            value: formState[question.id]
                                              ? {
                                                  label: formState[question.id],
                                                  value: formState[question.id],
                                                }
                                              : null,
                                            onChange: (address) =>
                                              handleAddressSelect(
                                                question.id,
                                                address,
                                              ),
                                            placeholder: Address
                                              ? null
                                              : "Enter your address...",
                                            styles: {
                                              control: (p) => ({
                                                ...p,
                                                borderColor: hasFieldError
                                                  ? "#e85347"
                                                  : p.borderColor,
                                                boxShadow: hasFieldError
                                                  ? "0 0 0 1px #e85347"
                                                  : p.boxShadow,
                                              }),
                                              input: (p) => ({
                                                ...p,
                                                color: "black",
                                                height: "35px",
                                              }),
                                              option: (p) => ({
                                                ...p,
                                                color: "black",
                                              }),
                                              singleValue: (p) => ({
                                                ...p,
                                                color: "black",
                                              }),
                                              menu: (p) => ({
                                                ...p,
                                                zIndex: 9,
                                              }),
                                            },
                                          }}
                                          className="googleLocation-autocomplete"
                                        />
                                      ) : question.validationValue ===
                                        "validation_country" ? (
                                        <Select
                                          id="_country"
                                          className="customCountrySelect-addClient"
                                          name="_country"
                                          label="Country"
                                          options={countryOptions}
                                          value={country}
                                          onChange={(selectedOption) =>
                                            handleChangeCountry(
                                              question.id,
                                              selectedOption,
                                            )
                                          }
                                          styles={{
                                            control: (p) => ({
                                              ...p,
                                              minHeight: "45px",
                                              borderColor: hasFieldError
                                                ? "#e85347"
                                                : p.borderColor,
                                              boxShadow: hasFieldError
                                                ? "0 0 0 1px #e85347"
                                                : p.boxShadow,
                                            }),
                                            menu: (p) => ({
                                              ...p,
                                              zIndex: 9,
                                            }),
                                          }}
                                          placeholder="Select Country"
                                        />
                                      ) : (
                                        <input
                                          className="form-control form-control-lg"
                                          style={errorBorderStyle}
                                          onChange={(e) =>
                                            handleChange(
                                              question.id,
                                              e.target.value,
                                              question.inputFormat,
                                            )
                                          }
                                          value={value}
                                          type="text"
                                          maxLength={question.maxLength || 100}
                                          autoComplete="off"
                                        />
                                      )}
                                    </div>
                                    {question.maxLength && (
                                      <small
                                        className="text-muted"
                                        style={{
                                          display: "block",
                                          marginTop: "4px",
                                        }}
                                      >
                                        • Maximum length is {question.maxLength}{" "}
                                        characters.
                                      </small>
                                    )}
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "textarea" && (
                                  <div className="form-group">
                                    <div className="form-control-wrap">
                                      <textarea
                                        className="form-control form-control-lg"
                                        style={errorBorderStyle}
                                        onChange={(e) =>
                                          handleChange(
                                            question.id,
                                            e.target.value,
                                          )
                                        }
                                        value={value}
                                        maxLength={question.maxLength || 500}
                                      />
                                    </div>
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "datetime" && (
                                  <div className="form-group">
                                    <DateTimePicker
                                      variant="inline"
                                      inputVariant="outlined"
                                      fullWidth
                                      format="dd MMM yyyy hh:mm a"
                                      error={hasFieldError}
                                      value={formState[question.id] || null}
                                      onChange={(d) =>
                                        handleChange(question.id, d)
                                      }
                                    />
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "date" && (
                                  <div className="form-group">
                                    <DatePicker
                                      variant="inline"
                                      inputVariant="outlined"
                                      fullWidth
                                      format="dd MMM yyyy"
                                      error={hasFieldError}
                                      value={formState[question.id] || null}
                                      onChange={(d) =>
                                        handleChange(question.id, d)
                                      }
                                    />
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "time" && (
                                  <div className="form-group">
                                    <TimePicker
                                      variant="inline"
                                      inputVariant="outlined"
                                      fullWidth
                                      error={hasFieldError}
                                      value={formState[question.id] || null}
                                      onChange={(t) =>
                                        handleChange(question.id, t)
                                      }
                                    />
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "dropdown" && (
                                  <div className="form-group">
                                    <div className="form-control-wrap">
                                      <div className="form-control-select">
                                        <select
                                          className="form-control form-control-lg"
                                          style={errorBorderStyle}
                                          onChange={(e) =>
                                            handleChange(
                                              question.id,
                                              e.target.value,
                                            )
                                          }
                                          value={value}
                                        >
                                          <option value="">
                                            Select an option
                                          </option>
                                          {question.options.map((opt, oi) => (
                                            <option key={oi} value={opt}>
                                              {opt}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "checkbox" && (
                                  <div style={{ marginTop: "8px" }}>
                                    {question.options.map((opt, oi) => {
                                      const isChecked = Array.isArray(
                                        formState[question.id],
                                      )
                                        ? formState[question.id].some(
                                            (v) =>
                                              v.toLowerCase() ===
                                              opt.toLowerCase(),
                                          )
                                        : formState[question.id]?.includes(
                                            opt,
                                          ) || false;
                                      const hKey = `cb_${question.id}_${oi}`;
                                      const isHovered = hoveredId === hKey;
                                      const showTeal = isChecked
                                        ? !isHovered
                                        : isHovered;
                                      return (
                                        <label
                                          key={oi}
                                          htmlFor={`sp_cb_${question.id}_${oi}`}
                                          onMouseEnter={() => setHoveredId(hKey)}
                                          onMouseLeave={() => setHoveredId(null)}
                                          style={{
                                            display: "flex",
                                            alignItems: "flex-start",
                                            gap: "14px",
                                            padding: "14px 16px",
                                            borderRadius: "8px",
                                            border: hasFieldError
                                              ? "1.5px solid #e85347"
                                              : showTeal
                                                ? "1.5px solid #1ee0ac"
                                                : "1.5px solid #e5e9f2",
                                            background: showTeal
                                              ? "#edfaf6"
                                              : "#ffffff",
                                            cursor: "pointer",
                                            transition: "all 0.15s ease",
                                            marginBottom: "10px",
                                            width: "100%",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            className="vdrSelected"
                                            id={`sp_cb_${question.id}_${oi}`}
                                            checked={isChecked}
                                            onChange={(e) =>
                                              handleCheckboxChange(
                                                question.id,
                                                opt,
                                                e.target.checked,
                                              )
                                            }
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              flexShrink: 0,
                                              marginTop: "1px",
                                              accentColor: "#1ee0ac",
                                              cursor: "pointer",
                                            }}
                                          />
                                          <span
                                            style={{
                                              fontSize: "13.5px",
                                              color: showTeal
                                                ? "#1c2b46"
                                                : "#526484",
                                              fontWeight: showTeal ? 600 : 400,
                                              lineHeight: 1.55,
                                              flex: 1,
                                            }}
                                          >
                                            {opt}
                                          </span>
                                        </label>
                                      );
                                    })}
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "radio" && (
                                  <div style={{ marginTop: "8px" }}>
                                    {question.options.map((opt, oi) => {
                                      const isSelected =
                                        formState[question.id] === opt;
                                      const hKey = `sp_radio_${question.id}_${oi}`;
                                      const isHovered = hoveredId === hKey;
                                      const showTeal = isSelected || isHovered;
                                      return (
                                        <label
                                          key={oi}
                                          htmlFor={hKey}
                                          onMouseEnter={() => setHoveredId(hKey)}
                                          onMouseLeave={() => setHoveredId(null)}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "14px",
                                            padding: "14px 16px",
                                            borderRadius: "8px",
                                            border: hasFieldError
                                              ? "1.5px solid #e85347"
                                              : showTeal
                                                ? "1.5px solid #1ee0ac"
                                                : "1.5px solid #e5e9f2",
                                            background: showTeal
                                              ? "#edfaf6"
                                              : "#ffffff",
                                            cursor: "pointer",
                                            transition: "all 0.15s ease",
                                            marginBottom: "10px",
                                            width: "100%",
                                          }}
                                        >
                                          <input
                                            type="radio"
                                            id={hKey}
                                            name={`sp_radio_${question.id}`}
                                            checked={isSelected}
                                            onChange={() =>
                                              handleChange(question.id, opt)
                                            }
                                            value={opt}
                                            style={{ display: "none" }}
                                          />
                                          <span
                                            style={{
                                              fontSize: "13.5px",
                                              color: showTeal
                                                ? "#1c2b46"
                                                : "#526484",
                                              fontWeight: showTeal ? 600 : 400,
                                              lineHeight: 1.55,
                                              flex: 1,
                                            }}
                                          >
                                            {opt}
                                          </span>
                                          <span
                                            style={{
                                              width: "24px",
                                              height: "24px",
                                              borderRadius: "50%",
                                              background: isSelected
                                                ? "#1ee0ac"
                                                : "transparent",
                                              border: isSelected
                                                ? "none"
                                                : "2px solid #d0d5dd",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              flexShrink: 0,
                                              transition: "all 0.15s ease",
                                            }}
                                          >
                                            {isSelected && (
                                              <svg
                                                width="13"
                                                height="13"
                                                viewBox="0 0 13 13"
                                                fill="none"
                                              >
                                                <path
                                                  d="M2 6.5L5 9.5L11 3.5"
                                                  stroke="white"
                                                  strokeWidth="2"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />
                                              </svg>
                                            )}
                                          </span>
                                        </label>
                                      );
                                    })}
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "image_input" && (
                                  <div className="form-group">
                                    <div
                                      className="form-control-group"
                                      id="fileContainer"
                                    >
                                      <input
                                        type="file"
                                        id={`sp_file_${question.id}`}
                                        className="file-block"
                                        style={errorBorderStyle}
                                        name="add_picture"
                                        accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv, .zip"
                                        onChange={(e) =>
                                          handleFileChange(question.id, e)
                                        }
                                      />
                                      {formState[question.id] && (
                                        <div className="uploaded-file-preview">
                                          {formState[question.id].match(
                                            /\.(jpeg|jpg|png)$/i,
                                          ) ? (
                                            <>
                                              <img
                                                src={`${APP_LIVE_URL}files_data/form_uploads/${formState[question.id]}`}
                                                alt="Uploaded preview"
                                                style={{ maxWidth: "100px" }}
                                              />
                                              <a
                                                onClick={() =>
                                                  removeUploadedFile(
                                                    question.id,
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  color: "red",
                                                  fontSize: "20px",
                                                  marginLeft: "5px",
                                                }}
                                                className="fs-20"
                                                title="Delete"
                                              >
                                                <em className="icon ni ni-trash-fill"></em>
                                              </a>
                                            </>
                                          ) : (
                                            <p>
                                              {formState[question.id]
                                                .split("/")
                                                .pop()}
                                              <a
                                                onClick={() =>
                                                  removeUploadedFile(
                                                    question.id,
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  color: "red",
                                                  fontSize: "20px",
                                                  marginLeft: "5px",
                                                }}
                                                className="fs-20"
                                                title="Delete"
                                              >
                                                <em className="icon ni ni-trash-fill"></em>
                                              </a>
                                            </p>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    {formErrors[question.id] && (
                                      <FormHelperText error>
                                        {formErrors[question.id]}
                                      </FormHelperText>
                                    )}
                                  </div>
                                )}
                                {question.answerType === "signature" && (
                                  <>
                                    <ul className="nav nav-tabs">
                                      <li className="nav-item">
                                        <a
                                          className={
                                            signatureType === "draw" ||
                                            signatureType === ""
                                              ? "nav-link active"
                                              : "nav-link"
                                          }
                                          data-toggle="tab"
                                          onClick={() => setSignatureType("draw")}
                                          href="#sp-tabDraw"
                                        >
                                          <em className="icon ni ni-edit-alt"></em>
                                          <span>E-sign</span>
                                        </a>
                                      </li>
                                      <li className="nav-item">
                                        <a
                                          className={
                                            signatureType === "choose"
                                              ? "nav-link active"
                                              : "nav-link"
                                          }
                                          data-toggle="tab"
                                          onClick={() =>
                                            setSignatureType("choose")
                                          }
                                          href="#sp-tabChoose"
                                        >
                                          <em className="icon ni ni-list-check"></em>
                                          <span>Type</span>
                                        </a>
                                      </li>
                                    </ul>
                                    <div className="tab-content">
                                      <div
                                        className={
                                          signatureType === "choose"
                                            ? "tab-pane active"
                                            : "tab-pane"
                                        }
                                        id="sp-tabChoose"
                                      >
                                        <div className="example-alert mb-4">
                                          <div className="alert alert-light">
                                            On the Type tab, enter your name to
                                            generate a live signature preview.
                                            You can then choose from the
                                            available font styles before saving.
                                          </div>
                                        </div>
                                        <div className="form-group mb-4">
                                          <div className="form-control-wrap">
                                            <input
                                              className="form-control form-control-lg"
                                              onChange={(e) =>
                                                handleChangeSignature(
                                                  question.id,
                                                  e.target.value,
                                                )
                                              }
                                              onInput={(e) => {
                                                e.target.value =
                                                  e.target.value.replace(
                                                    /[^a-zA-Z0-9 ]/gi,
                                                    "",
                                                  );
                                              }}
                                              value={signatureText}
                                              type="text"
                                              maxLength={100}
                                              placeholder="Authorized Person Name"
                                              autoComplete="off"
                                            />
                                          </div>
                                          {formErrors[question.id] && (
                                            <FormHelperText error>
                                              {formErrors[question.id]}
                                            </FormHelperText>
                                          )}
                                        </div>
                                        <h6 className="title">Choose Style</h6>
                                        <ul className="cc-pay-method">
                                          <li className="cc-pay-dd dropdown">
                                            <a
                                              href="#"
                                              className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator"
                                              data-toggle="dropdown"
                                            >
                                              <span
                                                style={{
                                                  fontFamily: signatureClass,
                                                }}
                                              >
                                                {signatureText ||
                                                  "Your Signature"}
                                              </span>
                                            </a>
                                            <div className="dropdown-menu dropdown-menu-auto">
                                              <ul className="link-list-plain">
                                                {cursiveFonts.map(
                                                  (font, fi) => (
                                                    <li key={fi}>
                                                      <a
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          setSignatureClass(
                                                            font.value,
                                                          )
                                                        }
                                                        className="cc-pay-item"
                                                      >
                                                        <span className="cc-pay-item-name">
                                                          <span
                                                            className="cc-pay-item-method"
                                                            style={{
                                                              fontFamily:
                                                                font.value,
                                                            }}
                                                          >
                                                            {signatureText !== ""
                                                              ? signatureText
                                                              : font.name}
                                                          </span>
                                                        </span>
                                                      </a>
                                                    </li>
                                                  ),
                                                )}
                                              </ul>
                                            </div>
                                          </li>
                                        </ul>
                                        <div
                                          className="signature-preview mt-3"
                                          id={`styled-text-container${question.id}`}
                                          style={{
                                            fontFamily: signatureClass,
                                            fontSize: "40px",
                                            height: "80px",
                                            backgroundColor: "transparent",
                                            border: "none",
                                            lineHeight: "80px",
                                            color: "#000",
                                          }}
                                        >
                                          {signatureText || "Your Signature"}
                                        </div>
                                        <div
                                          className="col-sm-12 mt-4 pl-0"
                                          style={{ clear: "both" }}
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-primary"
                                            style={{
                                              margin: "13px 0px 12px 0px",
                                            }}
                                            onClick={() =>
                                              saveChooseImage(question.id)
                                            }
                                          >
                                            <em className="icon ni ni-folder-check"></em>{" "}
                                            <span>Save Signature</span>
                                          </button>
                                        </div>
                                      </div>
                                      <div
                                        className={
                                          signatureType === "draw" ||
                                          signatureType === ""
                                            ? "tab-pane active"
                                            : "tab-pane"
                                        }
                                        id="sp-tabDraw"
                                      >
                                        <div className="row">
                                          <div className="col-sm-12">
                                            <div className="example-alert mb-4">
                                              <div className="alert alert-light">
                                                Draw your signature in the box
                                                below, then select Save Signature
                                                to continue. Clear resets the
                                                drawing area.
                                              </div>
                                            </div>
                                            {formState[question.id] && (
                                              <div className="uploaded-file-preview">
                                                <img
                                                  src={`${APP_LIVE_URL}files_data/form_uploads/${formState[question.id]}`}
                                                  alt="Uploaded Signature"
                                                  style={{ maxWidth: "200px" }}
                                                />
                                              </div>
                                            )}
                                            <div
                                              id={`divSig${question.id}`}
                                              style={{ display: "none" }}
                                            >
                                              <div className="mb-4">
                                                <img
                                                  src=""
                                                  className="clsimgSig"
                                                  height="100"
                                                  width="200"
                                                  alt=""
                                                />
                                              </div>
                                            </div>
                                            <div>
                                              <strong>Signature</strong>
                                            </div>
                                          </div>
                                          <div className="col-sm-12">
                                            <div
                                              style={
                                                hasFieldError
                                                  ? {
                                                      border:
                                                        "1px solid #e85347",
                                                      boxShadow:
                                                        "0 0 0 1px #e85347",
                                                      borderRadius: "4px",
                                                      display: "inline-block",
                                                    }
                                                  : undefined
                                              }
                                            >
                                              <SignatureCanvas
                                                clearOnResize={true}
                                                canvasProps={{
                                                  className: styles.sigPad,
                                                }}
                                                velocityFilterWeight={0.7}
                                                throttle={50}
                                                ref={(ref) =>
                                                  (sigPadRefs.current[
                                                    question.id
                                                  ] = ref)
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="col-sm-12 mt-4">
                                            <button
                                              className="btn btn-warning"
                                              style={{
                                                margin: "13px 0px 12px 0px",
                                              }}
                                              onClick={() =>
                                                clearSignature(question.id)
                                              }
                                              type="button"
                                            >
                                              <em className="icon ni ni-delete"></em>{" "}
                                              <span>Clear</span>
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-primary"
                                              style={{
                                                margin: "13px 0px 12px 10px",
                                              }}
                                              onClick={() =>
                                                saveSignature(question.id)
                                              }
                                            >
                                              <em className="icon ni ni-folder-check"></em>{" "}
                                              <span>Save Signature</span>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                                {question.answerType === "fixed" && (
                                  <>
                                    <div className="form-group mb-0">
                                      <div className="form-control-wrap">
                                        <input
                                          className="form-control form-control-lg"
                                          onChange={(e) =>
                                            handleChangeFixed(
                                              question.id,
                                              question.answer,
                                            )
                                          }
                                          value={question.answer}
                                          type="text"
                                          maxLength={255}
                                          autoComplete="off"
                                        />
                                      </div>
                                      {formErrors[question.id] && (
                                        <FormHelperText error>
                                          {formErrors[question.id]}
                                        </FormHelperText>
                                      )}
                                    </div>
                                    <CopyToClipboard
                                      text={question.answer}
                                      onCopy={() => setCopied(true)}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div className="form-note text-primary">
                                        <strong>
                                          Copy to Clipboard{" "}
                                          {copied ? (
                                            <span>
                                              <em className="icon ni ni-done"></em>
                                            </span>
                                          ) : null}
                                        </strong>
                                      </div>
                                    </CopyToClipboard>
                                  </>
                                )}
                                {question.answerType === "label" && (
                                  <div className="form-group mb-0">
                                    <h6></h6>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                ))}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "12px",
                    padding: "18px 0 4px",
                    marginTop: "12px",
                    borderTop: "1px solid #e5e9f2",
                  }}
                >
                  {allow_submit === 1 ? (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmitSinglePage}
                      disabled={loading}
                      style={{
                        minWidth: "160px",
                        height: "42px",
                        borderRadius: "6px",
                        fontWeight: 600,
                        fontSize: "14px",
                        textTransform: "none",
                        letterSpacing: "0.02em",
                        background: loading ? undefined : "#1c2b46",
                        boxShadow: "0 2px 10px rgba(28,43,70,0.3)",
                      }}
                    >
                      {loading ? (
                        "Submitting..."
                      ) : (
                        <>
                          <em
                            className="icon ni ni-check-thick"
                            style={{ marginRight: "6px" }}
                          ></em>
                          Submit Form
                        </>
                      )}
                    </Button>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 16px",
                        borderRadius: "6px",
                        background: "#fff8ea",
                        border: "1px solid #ffd591",
                        color: "#8a6c00",
                        fontSize: "13.5px",
                        fontWeight: 500,
                      }}
                    >
                      <em
                        className="icon ni ni-lock"
                        style={{ fontSize: "16px" }}
                      ></em>
                      Submission is disabled for this form.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : false ? (
          <>
            <div className="nk-block nk-block-lg">
              <div className="card">
                <form
                  className="nk-stepper stepper-init is-alter nk-stepper-s1"
                  action="#"
                  id="stepper-create-project"
                  data-step-current="2"
                  noValidate
                  style={{ display: "block" }}
                >
                  <div className="row g-0 col-sep col-sep-md col-sep-xl">
                    <div className="col-md-3 col-xl-3">
                      <div className="card-inner">
                        <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                          {groups.map((group, index) => (
                            <li
                              key={group.id}
                              className={
                                currentStep === index
                                  ? "current"
                                  : currentStep > index
                                    ? "done"
                                    : ""
                              }
                              style={{ marginBottom: "0.725rem" }}
                            >
                              <div
                                className="step-item"
                                data-group-number={index + 1}
                              >
                                <div className="step-text">
                                  <div className="lead-text">
                                    {group.group_title}
                                    {group.group_instructions &&
                                    group.group_instructions !== "" ? (
                                      <div className="custom-tooltip-wrapper">
                                        <em
                                          className="icon ni ni-info"
                                          style={{
                                            color: "#6576ff",
                                            marginLeft: "5px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                          }}
                                        ></em>

                                        <div className="custom-tooltip-box">
                                          {group.group_instructions
                                            .split("\n")
                                            .filter(
                                              (line) => line.trim() !== "",
                                            )
                                            .map((line, index) => (
                                              <p>{line}</p>
                                            ))}
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div
                      className="col-md-9 col-xl-9 p-0"
                      style={{ borderLeft: "1px solid #e5e9f2" }}
                    >
                      <div className="card-inner p-0">
                        <div className="nk-stepper-content">
                          <div className="nk-stepper-steps stepper-steps">
                            <div className="nk-kycfm">
                              <div
                                className="nk-kycfm-head"
                                style={{ background: "#fff" }}
                              >
                                <div className="nk-kycfm-title">
                                  <h5 className="title">
                                    {formTitle || "Untitled Form"}
                                  </h5>
                                  {currentStep === 0 && (
                                    <p className="sub-title">
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: formDescription,
                                        }}
                                      />
                                    </p>
                                  )}
                                </div>
                              </div>
                              <div className="nk-kycfm-content">
                                {responseMessage && (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: responseMessage,
                                    }}
                                  ></div>
                                )}
                                {errorMessage && (
                                  <div className="alert alert-danger alert-icon mb-3">
                                    <em className="icon ni ni-cross-circle"></em>{" "}
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: errorMessage,
                                      }}
                                    ></div>
                                  </div>
                                )}
                                {validationSummary && validationSummary.count > 0 && (
                                  <div className="mb-2" style={{ color: "#b45309", fontSize: "13px", fontWeight: 600 }}>
                                    {validationSummary.count} {validationSummary.count === 1 ? "field needs" : "fields need"} attention.
                                  </div>
                                )}
                                <div className="mb-3">
                                  <h5 className="title">
                                    {currentGroup.group_title}
                                  </h5>

                                  <p
                                    className="sub-title"
                                    dangerouslySetInnerHTML={{
                                      __html: currentGroup.group_desc
                                        ? currentGroup.group_desc.replace(
                                            /\n/g,
                                            "<br />",
                                          )
                                        : "",
                                    }}
                                  ></p>
                                </div>
                                <div className="row g-gs">
                                  {currentGroup.questions
                                    .map((questionId) => {
                                      // Find the corresponding question from formData
                                      const question =
                                        formData[0].questions.find(
                                          (q) => q.id === questionId,
                                        );
                                      return question;
                                    })
                                    .filter(Boolean) // Remove any undefined values if a question is not found
                                    .sort(
                                      (a, b) =>
                                        a.sequenceNumber - b.sequenceNumber,
                                    ) // Sort by sequence number
                                    .map((question) => {
                                      const value =
                                        formState[question.id] || "";
                                      const hasFieldError = Boolean(
                                        formErrors[question.id],
                                      );

                                      return (
                                        <div
                                          key={question.id}
                                          id={`field-${question.id}`}
                                          className={getQuestionColumnClass(
                                            currentGroup,
                                            question,
                                          )}
                                          style={
                                            hasFieldError
                                              ? {
                                                  borderLeft: "3px solid #e85347",
                                                  paddingLeft: "8px",
                                                }
                                              : undefined
                                          }
                                        >
                                          <div className="form-group question-text mb-0">
                                            {question.answerType === "label" ? (
                                              <label
                                                className="form-label"
                                                style={{ fontSize: "1.275rem" }}
                                              >
                                                {question.questionText}{" "}
                                                {question.required && (
                                                  <sup className="text-danger">
                                                    *
                                                  </sup>
                                                )}
                                              </label>
                                            ) : (
                                              <>
                                                {!isStaticTextAnswerType(
                                                  question.answerType,
                                                ) ? (
                                                  <label className="form-label">
                                                    {question.questionText}{" "}
                                                    {question.required && (
                                                      <sup className="text-danger">
                                                        *
                                                      </sup>
                                                    )}
                                                    {question.tooltip && question.tooltip.trim() !== "" && (
                                                      <div className="custom-tooltip-wrapper">
                                                        <em className="icon ni ni-info" style={{ color: "#6576ff", marginLeft: "5px", cursor: "pointer", fontSize: "16px" }}></em>
                                                        <div className="custom-tooltip-box"><p>{question.tooltip}</p></div>
                                                      </div>
                                                    )}
                                                  </label>
                                                ) : null}
                                              </>
                                            )}
                                            {isStaticTextAnswerType(
                                              question.answerType,
                                            )
                                              ? renderStaticContent(question)
                                              : null}
                                            {question.imageUrl && (
                                              <>
                                                <a
                                                  onClick={() =>
                                                    downloadPdf(
                                                      question.imageUrl,
                                                    )
                                                  }
                                                  style={{
                                                    float: "right",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <span className="badge badge-outline-primary">
                                                    <em className="icon ni ni-download"></em>{" "}
                                                    Download File
                                                  </span>
                                                </a>
                                              </>
                                            )}
                                          </div>

                                          {question.answerType === "input" && (
                                            <div className="form-group mb-0">
                                              <div className="form-control-wrap">
                                                {/* Phone validation */}
                                                {question.validationValue ===
                                                "validation_phone" ? (
                                                  <PhoneInput
                                                    className="customStyle-phone_input-add_sharelink_lead"
                                                    required
                                                    defaultCountry={"us"}
                                                    value={
                                                      formState[question.id] ||
                                                      ""
                                                    }
                                                    onChange={(value) =>
                                                      handleChangePhone(
                                                        question.id,
                                                        value,
                                                      )
                                                    }
                                                    ref={phoneInputRef}
                                                    onFocus={handleFocus}
                                                    inputStyle={
                                                      formErrors[question.id]
                                                        ? { borderColor: "#e85347", boxShadow: "0 0 0 1px #e85347" }
                                                        : undefined
                                                    }
                                                    countrySelectorStyleProps={{
                                                      buttonStyle: formErrors[question.id]
                                                        ? { borderColor: "#e85347" }
                                                        : undefined,
                                                    }}
                                                  />
                                                ) : question.validationValue ===
                                                  "validation_fulladdress" ? (
                                                  <GooglePlacesAutocomplete
                                                    apiKey={
                                                      process.env
                                                        .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                                    }
                                                    apiOptions={{ loading: 'async' }}
                                                    selectProps={{
                                                      value: formState[
                                                        question.id
                                                      ]
                                                        ? {
                                                            label:
                                                              formState[
                                                                question.id
                                                              ],
                                                            value:
                                                              formState[
                                                                question.id
                                                              ],
                                                          }
                                                        : null,
                                                      onChange: (address) =>
                                                        handleAddressSelect(
                                                          question.id,
                                                          address,
                                                        ),
                                                      placeholder: Address
                                                        ? null
                                                        : "Enter your address...",
                                                      styles: {
                                                        input: (provided) => ({
                                                          ...provided,
                                                          color: "black",
                                                          height: "35px",
                                                        }),
                                                        option: (provided) => ({
                                                          ...provided,
                                                          color: "black",
                                                        }),
                                                        singleValue: (
                                                          provided,
                                                        ) => ({
                                                          ...provided,
                                                          color: "black",
                                                        }),
                                                        menu: (provided) => ({
                                                          ...provided,
                                                          zIndex: 9,
                                                        }),
                                                      },
                                                    }}
                                                    className="googleLocation-autocomplete"
                                                  />
                                                ) : question.validationValue ===
                                                  "validation_country" ? (
                                                  <Select
                                                    id="_country"
                                                    className="customCountrySelect-addClient"
                                                    name="_country"
                                                    label="Country"
                                                    options={countryOptions}
                                                    value={country}
                                                    onChange={(
                                                      selectedOption,
                                                    ) =>
                                                      handleChangeCountry(
                                                        question.id,
                                                        selectedOption,
                                                      )
                                                    }
                                                    styles={{
                                                      control: (provided) => ({
                                                        ...provided,
                                                        minHeight: "45px",
                                                      }),
                                                      menu: (
                                                        provided,
                                                        state,
                                                      ) => ({
                                                        ...provided,
                                                        zIndex: 9,
                                                      }),
                                                    }}
                                                    placeholder="Select Country"
                                                  />
                                                ) : (
                                                  <input
                                                    className="form-control form-control-lg"
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                        question.inputFormat,
                                                      )
                                                    }
                                                    value={value}
                                                    type="text"
                                                    maxLength={
                                                      question.maxLength || 100
                                                    }
                                                    autoComplete="off"
                                                  />
                                                )}
                                              </div>
                                              <div
                                                className="helper-text"
                                                style={{ marginTop: "6px" }}
                                              >
                                                {question.maxLength && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Maximum length is{" "}
                                                    {question.maxLength}{" "}
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "number_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only numbers are allowed
                                                    (e.g. 123456).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphabet_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphabets are allowed
                                                    (e.g. JohnDoe).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphanumeric" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphanumeric characters
                                                    are allowed (e.g. John123).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "open" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    You can enter any
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                              </div>

                                              {/* Display form errors if present */}
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "signature" && (
                                            <>
                                              <ul className="nav nav-tabs">
                                                <li className="nav-item">
                                                  <a
                                                    className={
                                                      signatureType ===
                                                        "draw" ||
                                                      signatureType === ""
                                                        ? "nav-link active"
                                                        : "nav-link"
                                                    }
                                                    data-toggle="tab"
                                                    onClick={() =>
                                                      setSignatureType("draw")
                                                    }
                                                    href="#tabItem6"
                                                  >
                                                    <em className="icon ni ni-edit-alt"></em>
                                                    <span>Draw</span>
                                                  </a>
                                                </li>
                                              </ul>
                                              <div className="tab-content">
                                                <div
                                                  className={
                                                    signatureType === "choose"
                                                      ? "tab-pane active"
                                                      : "tab-pane"
                                                  }
                                                  id="tabItem5"
                                                >
                                                  <div className="example-alert mb-4">
                                                    <div className="alert alert-light">
                                                      Pick a style for your
                                                      signature (Authorized
                                                      Person Name).
                                                    </div>
                                                  </div>
                                                  <div className="form-group mb-4">
                                                    <div className="form-control-wrap">
                                                      <input
                                                        className={`form-control form-control-lg`}
                                                        onChange={(e) =>
                                                          handleChangeSignature(
                                                            question.id,
                                                            e.target.value,
                                                          )
                                                        }
                                                        onInput={(e) => {
                                                          e.target.value =
                                                            e.target.value.replace(
                                                              /[^a-zA-Z0-9 ]/gi,
                                                              "",
                                                            );
                                                        }}
                                                        value={signatureText}
                                                        type="text"
                                                        maxLength={100}
                                                        placeholder="Authorized Person Name"
                                                        autoComplete="off"
                                                      />
                                                    </div>
                                                    {formErrors[
                                                      question.id
                                                    ] && (
                                                      <FormHelperText error>
                                                        {
                                                          formErrors[
                                                            question.id
                                                          ]
                                                        }
                                                      </FormHelperText>
                                                    )}
                                                  </div>

                                                  <div className="row">
                                                    <div className="col-sm-6">
                                                      <h6 className="title">
                                                        Choose Style
                                                      </h6>

                                                      <ul className="cc-pay-method">
                                                        <li className="cc-pay-dd dropdown">
                                                          <a
                                                            href="#"
                                                            className="btn btn-white btn-outline-light dropdown-toggle dropdown-indicator"
                                                            data-toggle="dropdown"
                                                          >
                                                            <span
                                                              style={{
                                                                fontFamily:
                                                                  signatureClass,
                                                              }}
                                                            >
                                                              {signatureText ||
                                                                "Your Signature"}
                                                            </span>
                                                          </a>
                                                          <div className="dropdown-menu dropdown-menu-auto">
                                                            <ul className="link-list-plain">
                                                              {cursiveFonts.map(
                                                                (
                                                                  font,
                                                                  index,
                                                                ) => (
                                                                  <li
                                                                    key={index}
                                                                  >
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        setSignatureClass(
                                                                          font.value,
                                                                        )
                                                                      }
                                                                      className="cc-pay-item"
                                                                    >
                                                                      <span className="cc-pay-item-name">
                                                                        <span
                                                                          className="cc-pay-item-method"
                                                                          style={{
                                                                            fontFamily:
                                                                              font.value,
                                                                          }}
                                                                        >
                                                                          {signatureText !==
                                                                          ""
                                                                            ? signatureText
                                                                            : font.name}
                                                                        </span>
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ),
                                                              )}
                                                            </ul>
                                                          </div>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                    <div className="col-sm-6">
                                                      <div
                                                        className="signature-preview"
                                                        id={`styled-text-container${question.id}`}
                                                        style={{
                                                          fontFamily:
                                                            signatureClass,
                                                          fontSize: "40px",

                                                          height: "80px",
                                                          background:
                                                            "trasnparent",
                                                          backgroundColor:
                                                            "transparent",
                                                          border: "none",
                                                          lineHeight: "80px",
                                                          color: "#000",
                                                        }}
                                                      >
                                                        {signatureText ||
                                                          "Your Signature"}
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div
                                                    className="col-sm-12 mt-4 pl-0"
                                                    style={{ clear: "both" }}
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-primary"
                                                      style={{
                                                        margin:
                                                          "13px 0px 12px 0px",
                                                      }}
                                                      onClick={() =>
                                                        saveChooseImage(
                                                          question.id,
                                                        )
                                                      }
                                                    >
                                                      <em className="icon ni ni-folder-check"></em>{" "}
                                                      <span>
                                                        Save Signature
                                                      </span>
                                                    </button>
                                                  </div>
                                                </div>
                                                <div
                                                  className={
                                                    signatureType === "draw" ||
                                                    signatureType === ""
                                                      ? "tab-pane active"
                                                      : "tab-pane"
                                                  }
                                                  id="tabItem6"
                                                >
                                                  <div className="row">
                                                    <div className="col-sm-12">
                                                      <div className="example-alert mb-4">
                                                        <div className="alert alert-light">
                                                          Please Save the
                                                          signature to proceed.
                                                        </div>
                                                      </div>
                                                      {formState[
                                                        question.id
                                                      ] && (
                                                        <div className="uploaded-file-preview">
                                                          <img
                                                            src={`${APP_LIVE_URL}files_data/form_uploads/${
                                                              formState[
                                                                question.id
                                                              ]
                                                            }`}
                                                            alt="Uploaded Signature"
                                                            style={{
                                                              maxWidth: "200px",
                                                            }}
                                                          />
                                                        </div>
                                                      )}
                                                      <div
                                                        id={`divSig${question.id}`}
                                                        style={{
                                                          display: "none",
                                                        }}
                                                      >
                                                        <div className="mb-4">
                                                          <img
                                                            src=""
                                                            className="clsimgSig"
                                                            height="100"
                                                            width="200"
                                                            onerror="this.style.display='none'"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div>
                                                        <strong>
                                                          Signature
                                                        </strong>
                                                      </div>
                                                    </div>

                                                    <div className="col-sm-12">
                                                      <SignatureCanvas
                                                        clearOnResize={true}
                                                        canvasProps={{
                                                          className:
                                                            styles.sigPad,
                                                        }}
                                                        velocityFilterWeight={
                                                          0.7
                                                        }
                                                        throttle={50}
                                                        ref={(ref) =>
                                                          (sigPadRefs.current[
                                                            question.id
                                                          ] = ref)
                                                        }
                                                      />
                                                    </div>
                                                    <div className="col-sm-12 mt-4">
                                                      <button
                                                        className="btn btn-warning"
                                                        style={{
                                                          margin:
                                                            "13px 0px 12px 0px",
                                                        }}
                                                        onClick={() =>
                                                          clearSignature(
                                                            question.id,
                                                          )
                                                        }
                                                        type="button"
                                                      >
                                                        <em className="icon ni ni-delete"></em>{" "}
                                                        <span>Clear</span>
                                                      </button>
                                                      {/*<button
                                            className="btn btn-success"
                                            style={{
                                              margin: "13px 0px 12px 10px",
                                            }}
                                            type="button"
                                            onClick={() =>
                                              previewSignature(question.id)
                                            }
                                          >
                                            <em className="icon ni ni-eye"></em>{" "}
                                            <span>Preview</span>
                                          </button>*/}
                                                      <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        style={{
                                                          margin:
                                                            "13px 0px 12px 10px",
                                                        }}
                                                        onClick={() =>
                                                          saveSignature(
                                                            question.id,
                                                          )
                                                        }
                                                      >
                                                        <em className="icon ni ni-folder-check"></em>{" "}
                                                        <span>
                                                          Save Signature
                                                        </span>
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          )}
                                          {question.answerType === "fixed" && (
                                            <>
                                              <div className="form-group mb-0">
                                                <div className="form-control-wrap">
                                                  <input
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChangeFixed(
                                                        question.id,
                                                        question.answer,
                                                      )
                                                    }
                                                    value={question.answer}
                                                    type="text"
                                                    maxLength={255}
                                                    autoComplete="off"
                                                  />
                                                </div>
                                                {formErrors[question.id] && (
                                                  <FormHelperText error>
                                                    {formErrors[question.id]}
                                                  </FormHelperText>
                                                )}
                                              </div>
                                              <CopyToClipboard
                                                text={question.answer}
                                                onCopy={() => setCopied(true)}
                                                style={{ cursor: "pointer" }}
                                              >
                                                <div className="form-note text-primary">
                                                  <strong>
                                                    Copy to Clipboard{" "}
                                                    {copied ? (
                                                      <span>
                                                        <em className="icon ni ni-done"></em>
                                                      </span>
                                                    ) : null}
                                                  </strong>
                                                </div>
                                              </CopyToClipboard>
                                            </>
                                          )}
                                          {question.answerType === "label" && (
                                            <div className="form-group mb-0">
                                              <h6></h6>
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "textarea" && (
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <textarea
                                                  className={`form-control form-control-lg`}
                                                  onChange={(e) =>
                                                    handleChange(
                                                      question.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                  placeholder=""
                                                  value={value}
                                                  maxLength={
                                                    question.maxLength || 500
                                                  }
                                                ></textarea>
                                              </div>
                                              <div
                                                className="helper-text"
                                                style={{ marginTop: "6px" }}
                                              >
                                                {question.maxLength && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Maximum length is{" "}
                                                    {question.maxLength}{" "}
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "number_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only numbers are allowed
                                                    (e.g. 123456).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphabet_only" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphabets are allowed
                                                    (e.g. JohnDoe).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "alphanumeric" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    Only alphanumeric characters
                                                    are allowed (e.g. John123).
                                                    <br />
                                                  </small>
                                                )}
                                                {question.inputFormat ===
                                                  "open" && (
                                                  <small
                                                    className="text-muted"
                                                    style={{ display: "block" }}
                                                  >
                                                    <span
                                                      style={{
                                                        marginRight: "5px",
                                                      }}
                                                    >
                                                      •
                                                    </span>{" "}
                                                    You can enter any
                                                    characters.
                                                    <br />
                                                  </small>
                                                )}
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "datetime" && (
                                            <div className="form-group">
                                              <DateTimePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                format="dd MMM yyyy hh:mm a"
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(date) =>
                                                  handleChange(
                                                    question.id,
                                                    date,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType === "date" && (
                                            <div className="form-group">
                                              <DatePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                format="dd MMM yyyy"
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(date) =>
                                                  handleChange(
                                                    question.id,
                                                    date,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType === "time" && (
                                            <div className="form-group">
                                              <TimePicker
                                                variant="inline"
                                                inputVariant="outlined"
                                                fullWidth
                                                value={
                                                  formState[question.id] || null
                                                }
                                                onChange={(time) =>
                                                  handleChange(
                                                    question.id,
                                                    time,
                                                  )
                                                }
                                              />
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "dropdown" && (
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <div className="form-control-select">
                                                  <select
                                                    className={`form-control form-control-lg`}
                                                    onChange={(e) =>
                                                      handleChange(
                                                        question.id,
                                                        e.target.value,
                                                      )
                                                    }
                                                    value={value}
                                                  >
                                                    <option value="">
                                                      Select an option
                                                    </option>
                                                    {question.options.map(
                                                      (option, index) => (
                                                        <option
                                                          key={index}
                                                          value={option}
                                                        >
                                                          {option}
                                                        </option>
                                                      ),
                                                    )}
                                                  </select>
                                                </div>
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "checkbox" && (
                                            <>
                                              <div className="mt-2 prettyprint ">
                                                <div className="row">
                                                  {question.options.map(
                                                    (option, index) => (
                                                      <div
                                                        className="col-md-12 mb-1"
                                                        key={`options_${index}`}
                                                      >
                                                        <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                          <input
                                                            type="checkbox"
                                                            className="custom-control-input vdrSelected"
                                                            id={`question_checkbox_${question.id}_${index}`}
                                                            checked={
                                                              formState[
                                                                question.id
                                                              ]?.includes(
                                                                option,
                                                              ) || false
                                                            }
                                                            onChange={(e) =>
                                                              handleCheckboxChange(
                                                                question.id,
                                                                option,
                                                                e.target
                                                                  .checked,
                                                              )
                                                            }
                                                          />
                                                          <label
                                                            className="custom-control-label"
                                                            htmlFor={`question_checkbox_${question.id}_${index}`}
                                                          >
                                                            {option}
                                                          </label>
                                                        </div>
                                                        {formErrors[
                                                          question.id
                                                        ] && (
                                                          <FormHelperText error>
                                                            {
                                                              formErrors[
                                                                question.id
                                                              ]
                                                            }
                                                          </FormHelperText>
                                                        )}
                                                      </div>
                                                    ),
                                                  )}
                                                </div>
                                              </div>
                                            </>
                                          )}

                                          {question.answerType === "radio" && (
                                            <div className="form-pm-group">
                                              <ul className="buysell-pm-list">
                                                {question.options.map(
                                                  (option, index) => (
                                                    <li
                                                      className="buysell-pm-item"
                                                      key={index}
                                                    >
                                                      <input
                                                        className="buysell-pm-control"
                                                        type="radio"
                                                        name={`radio_${question.id}`}
                                                        id={`radio_${question.id}_${index}`}
                                                        checked={
                                                          formState[
                                                            question.id
                                                          ]?.includes(option) ||
                                                          false
                                                        }
                                                        onChange={(e) =>
                                                          handleChange(
                                                            question.id,
                                                            option,
                                                          )
                                                        }
                                                        value={option}
                                                      />
                                                      <label
                                                        className="buysell-pm-label"
                                                        htmlFor={`radio_${question.id}_${index}`}
                                                      >
                                                        <span className="pm-name">
                                                          {option}
                                                        </span>
                                                        <span className="pm-icon">
                                                          {/*<em className="icon ni ni-question"></em>*/}
                                                        </span>
                                                      </label>
                                                    </li>
                                                  ),
                                                )}
                                              </ul>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                          {question.answerType ===
                                            "image_input" && (
                                            <div className="form-group">
                                              <div
                                                className="form-control-group"
                                                id="fileContainer"
                                              >
                                                <input
                                                  type="file"
                                                  id={`add_picture_${question.id}`}
                                                  className="file-block"
                                                  name="add_picture"
                                                  accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv, .zip"
                                                  onChange={(e) =>
                                                    handleFileChange(
                                                      question.id,
                                                      e,
                                                    )
                                                  }
                                                />
                                                {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                                {formState[question.id] && (
                                                  <div className="uploaded-file-preview">
                                                    {formState[
                                                      question.id
                                                    ].match(
                                                      /\.(jpeg|jpg|png)$/i,
                                                    ) ? (
                                                      <>
                                                        <img
                                                          src={`${APP_LIVE_URL}files_data/form_uploads/${
                                                            formState[
                                                              question.id
                                                            ]
                                                          }`}
                                                          alt="Uploaded preview"
                                                          style={{
                                                            maxWidth: "100px",
                                                          }}
                                                        />
                                                        <a
                                                          onClick={() =>
                                                            removeUploadedFile(
                                                              question.id,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                            fontSize: "20px",
                                                            marginLeft: "5px",
                                                          }}
                                                          className="fs-20"
                                                          title="Delete"
                                                        >
                                                          <em className="icon ni ni-trash-fill"></em>
                                                        </a>
                                                      </>
                                                    ) : (
                                                      <p>
                                                        {formState[question.id]
                                                          .split("/")
                                                          .pop()}
                                                        <a
                                                          onClick={() =>
                                                            removeUploadedFile(
                                                              question.id,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                            color: "red",
                                                            fontSize: "20px",
                                                            marginLeft: "5px",
                                                          }}
                                                          className="fs-20"
                                                          title="Delete"
                                                        >
                                                          <em className="icon ni ni-trash-fill"></em>
                                                        </a>
                                                      </p> // Display file name for non-images
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                              {formErrors[question.id] && (
                                                <FormHelperText error>
                                                  {formErrors[question.id]}
                                                </FormHelperText>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          margin: "20px",
                        }}
                      >
                        {currentStep > 0 && (
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setCurrentStep(currentStep - 1)}
                          >
                            Back
                          </Button>
                        )}
                        {currentStep < groups.length - 1 ? (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleNextStep}
                            style={{ marginLeft: "10px" }}
                            disabled={loading}
                          >
                            Save & Continue
                          </Button>
                        ) : (
                          <>
                            {allow_submit === 1 && (
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSubmit}
                                style={{ marginLeft: "10px" }}
                                disabled={loading}
                              >
                                {loading ? "Loading..." : "Save & Finish"}
                              </Button>
                            )}
                            {allow_submit === 0 && (
                              <button
                                type="button"
                                className="btn btn-outline-warning"
                                style={{ marginLeft: "10px" }}
                              >
                                Submission is disabled for this form.
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </>
        ) : (
          hasUngroupedQuestions && (
            <>
              <div className="nk-block nk-block-lg">
                <div className="card">
                  <form
                    className="nk-stepper stepper-init is-alter nk-stepper-s1"
                    action="#"
                    id="stepper-create-project"
                    data-step-current="2"
                    noValidate
                    style={{ display: "block" }}
                  >
                    <div className="row g-0 col-sep col-sep-md col-sep-xl">
                      <div className="col-md-3 col-xl-3">
                        <div className="card-inner">
                          <ul className="nk-stepper-nav nk-stepper-nav-s1 stepper-nav is-vr">
                            {groups.map((group, index) => (
                              <li
                                key={group.id}
                                className={
                                  currentStep === index
                                    ? "current"
                                    : currentStep > index
                                      ? "done"
                                      : ""
                                }
                              >
                                <div className="step-item">
                                  <div className="step-text">
                                    <div className="lead-text">
                                      {group.group_title}
                                    </div>
                                    <div
                                      className="sub-text"
                                      dangerouslySetInnerHTML={{
                                        __html: group.group_desc,
                                      }}
                                    ></div>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      <div className="col-md-7 col-xl-7">
                        <div className="card-inner">
                          <div className="nk-stepper-content">
                            <div className="nk-stepper-steps stepper-steps">
                              <div className="nk-kycfm">
                                <div
                                  className="nk-kycfm-head"
                                  style={{ background: "#f5f6fa" }}
                                >
                                  <div className="nk-kycfm-title">
                                    <h5 className="title">
                                      {formTitle || "Untitled Form"}
                                    </h5>
                                    <p className="sub-title">
                                      {formDescription || "Untitled Form"}
                                    </p>
                                  </div>
                                </div>
                                <div className="nk-kycfm-content">
                                  {responseMessage && (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: responseMessage,
                                      }}
                                    ></div>
                                  )}
                                  {errorMessage && (
                                    <div className="alert alert-danger alert-icon mb-3">
                                      <em className="icon ni ni-cross-circle"></em>{" "}
                                      Please fill out all the required
                                      questions!
                                    </div>
                                  )}
                                  <div className="row g-gs">
                                    {ungroupedQuestions.map((question) => (
                                      <div
                                        key={question.id}
                                        className={
                                          question.answerType === "label" ||
                                          isStaticTextAnswerType(
                                            question.answerType,
                                          )
                                            ? "question-container col-sm-12"
                                            : "question-container col-sm-6"
                                        }
                                      >
                                        <div className="form-group question-text mb-0">
                                          {!isStaticTextAnswerType(
                                            question.answerType,
                                          ) ? (
                                            <label className="form-label">
                                              {question.questionText}{" "}
                                              {question.required && (
                                                <sup className="text-danger">
                                                  *
                                                </sup>
                                              )}
                                            </label>
                                          ) : null}
                                        </div>
                                        {isStaticTextAnswerType(
                                          question.answerType,
                                        )
                                          ? renderStaticContent(question)
                                          : null}
                                        {question.imageUrl && (
                                          <img
                                            src={question.imageUrl}
                                            alt="Admin Uploaded"
                                            className="question-image"
                                          />
                                        )}
                                        {question.answerType === "input" && (
                                          <div className="form-group mb-0">
                                            <div className="form-control-wrap">
                                              <input
                                                className={`form-control form-control-lg`}
                                                onChange={(e) =>
                                                  handleChange(
                                                    question.id,
                                                    e.target.value,
                                                  )
                                                }
                                                type="text"
                                                maxLength={100}
                                                autoComplete="off"
                                              />
                                            </div>
                                            {formErrors[question.id] && (
                                              <FormHelperText error>
                                                {formErrors[question.id]}
                                              </FormHelperText>
                                            )}
                                          </div>
                                        )}
                                        {question.answerType === "textarea" && (
                                          <div className="form-group">
                                            <div className="form-control-wrap">
                                              <textarea
                                                className={`form-control form-control-lg`}
                                                onChange={(e) =>
                                                  handleChange(
                                                    question.id,
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder=""
                                                maxLength={500}
                                              ></textarea>
                                            </div>
                                            {formErrors[question.id] && (
                                              <FormHelperText error>
                                                {formErrors[question.id]}
                                              </FormHelperText>
                                            )}
                                          </div>
                                        )}
                                        {question.answerType === "datetime" && (
                                          <div className="form-group">
                                            <DateTimePicker
                                              variant="inline"
                                              inputVariant="outlined"
                                              fullWidth
                                              format="dd MMM yyyy hh:mm a"
                                              value={
                                                formState[question.id] || null
                                              }
                                              onChange={(date) =>
                                                handleChange(question.id, date)
                                              }
                                            />
                                            {formErrors[question.id] && (
                                              <FormHelperText error>
                                                {formErrors[question.id]}
                                              </FormHelperText>
                                            )}
                                          </div>
                                        )}
                                        {question.answerType === "date" && (
                                          <div className="form-group">
                                            <DatePicker
                                              variant="inline"
                                              inputVariant="outlined"
                                              fullWidth
                                              format="dd MMM yyyy"
                                              value={
                                                formState[question.id] || null
                                              }
                                              onChange={(date) =>
                                                handleChange(question.id, date)
                                              }
                                            />
                                            {formErrors[question.id] && (
                                              <FormHelperText error>
                                                {formErrors[question.id]}
                                              </FormHelperText>
                                            )}
                                          </div>
                                        )}
                                        {question.answerType === "time" && (
                                          <div className="form-group">
                                            <TimePicker
                                              variant="inline"
                                              inputVariant="outlined"
                                              fullWidth
                                              value={
                                                formState[question.id] || null
                                              }
                                              onChange={(time) =>
                                                handleChange(question.id, time)
                                              }
                                            />
                                            {formErrors[question.id] && (
                                              <FormHelperText error>
                                                {formErrors[question.id]}
                                              </FormHelperText>
                                            )}
                                          </div>
                                        )}
                                        {question.answerType === "dropdown" && (
                                          <div className="form-group">
                                            <div className="form-control-wrap">
                                              <div className="form-control-select">
                                                <select
                                                  className={`form-control form-control-lg`}
                                                  onChange={(e) =>
                                                    handleChange(
                                                      question.id,
                                                      e.target.value,
                                                    )
                                                  }
                                                >
                                                  <option value="">
                                                    Select an option
                                                  </option>
                                                  {question.options.map(
                                                    (option, index) => (
                                                      <option
                                                        key={index}
                                                        value={option}
                                                      >
                                                        {option}
                                                      </option>
                                                    ),
                                                  )}
                                                </select>
                                              </div>
                                            </div>
                                            {formErrors[question.id] && (
                                              <FormHelperText error>
                                                {formErrors[question.id]}
                                              </FormHelperText>
                                            )}
                                          </div>
                                        )}
                                        {question.answerType === "checkbox" && (
                                          <>
                                            <div className="mt-2 prettyprint ">
                                              <div className="row">
                                                {question.options.map(
                                                  (option, index) => (
                                                    <div
                                                      className="col-md-6 mb-1"
                                                      key={`options_${index}`}
                                                    >
                                                      <div className="custom-control custom-control-md custom-checkbox custom-control-pro">
                                                        <input
                                                          type="checkbox"
                                                          className="custom-control-input vdrSelected"
                                                          id={`question_checkbox_${question.id}_${index}`}
                                                          checked={
                                                            formState[
                                                              question.id
                                                            ]?.includes(
                                                              option,
                                                            ) || false
                                                          }
                                                          onChange={(e) =>
                                                            handleCheckboxChange(
                                                              question.id,
                                                              option,
                                                              e.target.checked,
                                                            )
                                                          }
                                                        />
                                                        <label
                                                          className="custom-control-label"
                                                          htmlFor={`question_checkbox_${question.id}_${index}`}
                                                        >
                                                          {option}
                                                        </label>
                                                      </div>
                                                      {formErrors[
                                                        question.id
                                                      ] && (
                                                        <FormHelperText error>
                                                          {
                                                            formErrors[
                                                              question.id
                                                            ]
                                                          }
                                                        </FormHelperText>
                                                      )}
                                                    </div>
                                                  ),
                                                )}
                                              </div>
                                            </div>
                                          </>
                                        )}

                                        {question.answerType === "radio" && (
                                          <div className="form-pm-group">
                                            <ul className="buysell-pm-list">
                                              {question.options.map(
                                                (option, index) => (
                                                  <li
                                                    className="buysell-pm-item"
                                                    key={index}
                                                  >
                                                    <input
                                                      className="buysell-pm-control"
                                                      type="radio"
                                                      name={`radio_${question.id}`}
                                                      id={`radio_${question.id}_${index}`}
                                                      checked={
                                                        formState[
                                                          question.id
                                                        ]?.includes(option) ||
                                                        false
                                                      }
                                                      onChange={(e) =>
                                                        handleChange(
                                                          question.id,
                                                          option,
                                                        )
                                                      }
                                                    />
                                                    <label
                                                      className="buysell-pm-label"
                                                      htmlFor={`radio_${question.id}_${index}`}
                                                    >
                                                      <span className="pm-name">
                                                        {option}
                                                      </span>
                                                      <span className="pm-icon">
                                                        {/*<em className="icon ni ni-question"></em>*/}
                                                      </span>
                                                    </label>
                                                  </li>
                                                ),
                                              )}
                                            </ul>
                                            {formErrors[question.id] && (
                                              <FormHelperText error>
                                                {formErrors[question.id]}
                                              </FormHelperText>
                                            )}
                                          </div>
                                        )}
                                        {question.answerType ===
                                          "image_input" && (
                                          <div className="form-group">
                                            <div
                                              className="form-control-group"
                                              id="fileContainer"
                                            >
                                              <input
                                                type="file"
                                                id={`add_picture_${question.id}`}
                                                className="file-block"
                                                name="add_picture"
                                                accept=".png, .jpg, .jpeg, .pdf, .doc, .docx, .xlx, .xlxs, .csv, .zip"
                                                onChange={(e) =>
                                                  handleFileChange(
                                                    question.id,
                                                    e,
                                                  )
                                                }
                                              />
                                              {/* Display the uploaded file name or image preview if the URL exists in the state */}
                                              {formState[question.id] && (
                                                <div className="uploaded-file-preview">
                                                  {formState[question.id].match(
                                                    /\.(jpeg|jpg|png)$/i,
                                                  ) ? (
                                                    <>
                                                      <img
                                                        src={`${APP_LIVE_URL}files_data/form_uploads/${
                                                          formState[question.id]
                                                        }`}
                                                        alt="Uploaded preview"
                                                        style={{
                                                          maxWidth: "100px",
                                                        }}
                                                      />
                                                      <a
                                                        onClick={() =>
                                                          removeUploadedFile(
                                                            question.id,
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                          color: "red",
                                                          fontSize: "20px",
                                                          marginLeft: "5px",
                                                        }}
                                                        className="fs-20"
                                                        title="Delete"
                                                      >
                                                        <em className="icon ni ni-trash-fill"></em>
                                                      </a>
                                                    </>
                                                  ) : (
                                                    <p>
                                                      {formState[question.id]
                                                        .split("/")
                                                        .pop()}
                                                      <a
                                                        onClick={() =>
                                                          removeUploadedFile(
                                                            question.id,
                                                          )
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                          color: "red",
                                                          fontSize: "20px",
                                                          marginLeft: "5px",
                                                        }}
                                                        className="fs-20"
                                                        title="Delete"
                                                      >
                                                        <em className="icon ni ni-trash-fill"></em>
                                                      </a>
                                                    </p> // Display file name for non-images
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                            {formErrors[question.id] && (
                                              <FormHelperText error>
                                                {formErrors[question.id]}
                                              </FormHelperText>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            margin: "20px",
                          }}
                        >
                          {allow_submit === 1 && (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleSubmit}
                              style={{ marginLeft: "10px" }}
                            >
                              Submit
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </>
          )
        )}
      </div>
    </MuiPickersUtilsProvider>
  );
};

export default FormRenderer;
